import React, { useMemo, useState,useRef,useEffect,useCallback } from "react";
import Sidebar from "../../components/Sidebar";
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import { Plus, X, RefreshCcw, Search, AlertTriangle, Edit2, Edit, Check, RotateCcw, Star, ChevronUp, ChevronDown, Settings, ClipboardList, Clock3, PersonStanding, Smile, Scale, Syringe, LayoutGrid } from "lucide-react";
import "../../configuration.css";
import {API_BASE_URL} from "../../app_url";
import {
  fetchAntecedentTitles,fetchAllergensByGroup ,fetchTimelineTemplate ,  fetchTimelineCards, createTimelineCard, updateTimelineCard, deleteTimelineCard,
  fetchTimelineTemplates, createTimelineTemplate, 
  setTimelineTemplateSteps,fetchChartsList, fetchChartByParam ,fetchProtocolCategories,getDiagnosticTitlesApi,  createChartsConfigApi, 
  updateChartsConfigApi, fetchChartsssList,updateTimelineTemplate,deleteTimelineTemplate,listDiagnosticsApi,
  deleteChartsConfigApi, fetchTimelineEtapes, createTimelineEtape, deleteTimelineEtape,
  fetchProtocolExamsByCategory, deleteDiagnosticApi
} from "../../services/apiService";
import axios from "axios";
import QuestionnairePlugin from "../../components/consultation/QuestionnairePlugin";
import { AtlasPluginSettings } from "../../components/consultation/AtlasPlugin";
import { OdontogramPluginSettings } from "../../components/consultation/odontogram/OdontogramPlugin";
import { BmiPluginSettings } from "../../components/consultation/bmi/BmiPlugin";
import { ShortcutsPluginSettings } from "../../components/consultation/shortcuts/shortcutsSettings";
/* ---------- Bouton d’onglet ---------- */
const TabBtn = ({ active, onClick, children }) => (
  <button className={`TabBtn ${active ? "is-active" : ""}`} onClick={onClick} type="button">
    {children}
  </button>
);

export default function DoctorConfiguration() {
  const [tab, setTab] = useState("services");

  return (
    <div className="doctorLayout">
      {/* Sidebar à gauche */}
      <Sidebar />

      {/* Contenu principal */}
      <div className="doctorMain far">
        {/* Header global du dashboard */}
        <DashboardDoctorHeader title="Configuration" />

        {/* Page */}
        <div className="ConfigPage">
          <header className="ConfigHeader">
            <h1>Configuration</h1>
          </header>

          <nav className="TabBar">
            <TabBtn active={tab === "services"} onClick={() => setTab("services")}>Services</TabBtn>
            <TabBtn active={tab === "stocks"} onClick={() => setTab("stocks")}>Stocks</TabBtn>
            <TabBtn active={tab === "indices"} onClick={() => setTab("indices")}>Charts</TabBtn>
            <TabBtn active={tab === "antecedents"} onClick={() => setTab("antecedents")}>Antécédents</TabBtn>
            <TabBtn active={tab === "allergies"} onClick={() => setTab("allergies")}>Allergies</TabBtn>
            <TabBtn active={tab === "diagnostique"} onClick={() => setTab("diagnostique")}>diagnostique</TabBtn>
            <TabBtn active={tab === "plugins"} onClick={() => setTab("plugins")}>Plugins</TabBtn>
          </nav>

          <section className="TabContent">
            {tab === "services" && <ServicesExamens />}
            {tab === "stocks" && <Stocks />}
            {tab === "indices" && <IndicesCharts />}
            {tab === "antecedents" && <SimpleList title="Listes des antécédents" />}
            {tab === "allergies" && <SimpleListt title="Listes des allergies" />}
            {tab === "diagnostique" && <SimpleListtt title="Listes des diagnostiques" />}
            {tab === "plugins" && <PluginsConfiguration />}
            {tab === "questionnaire" && <QuestionnairePlugin />}
          </section>
        </div>
      </div>
    </div>
  );
}
function buildAuthHeaders() {
  const token = localStorage.getItem("token"); // ou où tu stockes le JWT
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  };
}


function getDoctorIdFromLoginInfo() {
  try {
    const raw = localStorage.getItem("doctolikLoginInfo");
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v?.users?.id ?? v?.user?.id ?? v?.doctor?.id ?? v?.data?.user?.id ?? null;
  } catch {
    return null;
  }
}

function getHeader() {
  try {
    const raw = localStorage.getItem("doctolikLoginInfo");
    if (!raw) return {};
    const v = JSON.parse(raw);
    const tok = v?.authorisation?.token ?? v?.authorization?.token ?? v?.token;
    return tok ? { headers: { Authorization: `Bearer ${tok}`, "Cache-Control": "no-cache" } } : {};
  } catch {
    return {};
  }
}

// API endpoints
const API_BASE = API_BASE_URL.replace(/\/+$/, "");
const doctorBase = (id) => `${API_BASE}/doctor/${id}`;

// --- configs d'antécédents
export const listAntecedentConfigsApi = async (doctorId) => {
  return axios.get(`${doctorBase(doctorId)}/config/antecedents`, getHeader());
};

export const saveAntecedentConfigApi = async (doctorId, payload) => {
  return axios.post(`${doctorBase(doctorId)}/config/antecedents/save`, payload, getHeader());
};

export const deleteAntecedentConfigApi = async (doctorId, id) => {
  return axios.delete(`${doctorBase(doctorId)}/config/antecedents/${id}`, getHeader());
};

export async function saveDiagnosticApi(doctorId, payload) {
  const url = `${API_BASE_URL}doctor/${doctorId}/config/diagnostics/save`;
  return axios.post(url, payload, buildAuthHeaders());
}

// --- allergènes
export const fetchAllAllergens = async () => {
  const url = `${API_BASE}/doctor/allergens`;
  const { data } = await axios.get(url, getHeader());
  const arr = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
  return (arr || [])
    .map((r) => ({
      categorie: String(r?.categorie ?? r?.groupe ?? "").trim(),
      allergene: String(r?.allergene ?? r?.element ?? "").trim(),
    }))
    .filter((r) => r.categorie && r.allergene);
};


export const listAllergieConfigsApi = async (doctorId) => {
  return axios.get(`${doctorBase(doctorId)}/config/allergies`, getHeader());
};

export const saveAllergieConfigApi = async (doctorId, payload) => {
  return axios.post(`${doctorBase(doctorId)}/config/allergies/save`, payload, getHeader());
};

export const deleteAllergieConfigApi = async (doctorId, id) => {
  return axios.delete(`${doctorBase(doctorId)}/config/allergies/${id}`, getHeader());
};
function listDiagnosticConfigsApi() {
  const doctorId = getDoctorIdFromLoginInfo();
  const url = `${API_BASE_URL}doctor/${doctorId}/config/diagnostics`;
  return axios.get(url, buildAuthHeaders());
}
function saveDiagnosticConfigApi(payload) {
  const doctorId = getDoctorIdFromLoginInfo();
  const url = `${API_BASE_URL}doctor/${doctorId}/config/diagnostics/save`;
  return axios.post(url, payload, buildAuthHeaders());
}
function updateDiagnosticConfigApi(id, payload) {
  const doctorId = getDoctorIdFromLoginInfo();
  const url = `${API_BASE_URL}doctor/${doctorId}/config/diagnostics/${encodeURIComponent(id)}`;
  return axios.put(url, payload, buildAuthHeaders());
}
function deleteDiagnosticConfigApi(id) {
  const doctorId = getDoctorIdFromLoginInfo();
  const url = `${API_BASE_URL}doctor/${doctorId}/config/diagnostics/${encodeURIComponent(id)}`;
  return axios.delete(url, buildAuthHeaders());
}



// Auth: ajuste selon ton app

/* ---------- Onglet 1 : Services / Examens ---------- */

function ServicesExamens() {
  const [rows, setRows] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [loadingCats, setLoadingCats] = React.useState(false);

  const [suggestions, setSuggestions] = React.useState({});
  const [loadingRow, setLoadingRow] = React.useState({});
  const [savingRow, setSavingRow] = React.useState({});
  const [rowMsg, setRowMsg] = React.useState({});
  const debounceRefs = React.useRef({});

  const hydratedSet = React.useRef(new Set());
  const lastMsgAtRef = React.useRef(0);

  // focus auto sur le champ Nom de la ligne ciblée
  const [focusId, setFocusId] = React.useState(null);
  // savoir si le champ Nom d'une ligne est actuellement focus
  const [nameFocusedId, setNameFocusedId] = React.useState(null);
  // Style for consistent input width (same as stock input)
  const serviceInputStyle = { width: 120 };

  // ===== stocks pour auto-compléter
  const DOC_doctorId = React.useMemo(getDoctorIdFromLoginInfo, []);
  const [allStocks, setAllStocks] = React.useState([]);
  const [loadingStocks, setLoadingStocks] = React.useState(false);
  const keyStock = (rowId, idx) => `${rowId}|stock${idx}`;

  // ===== utils =====
  const cryptoRandom = React.useMemo(
    () => () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );

  const toInt = (v, min = null) => {
    let n = Number(String(v ?? "").replace(",", ".").trim());
    if (!Number.isFinite(n)) n = 0;
    if (min !== null) n = Math.max(min, n);
    return Math.trunc(n);
  };
  const sumQte = (row) => {
    const s = toInt(row.q1) + toInt(row.q2) + toInt(row.q3) + toInt(row.q4);
    return s > 0 ? s : 1;
  };
  const mergeStableOrder = (prev, incoming) => {
    const prevIds = prev.map((x) => String(x.id));
    const incMap = new Map(incoming.map((x) => [String(x.id), x]));
    const out = [];
    for (const id of prevIds) {
      if (incMap.has(id)) {
        out.push(incMap.get(id));
        incMap.delete(id);
      }
    }
    for (const x of incoming) {
      const id = String(x.id);
      if (incMap.has(id)) out.push(incMap.get(id));
    }
    return out;
  };

  /* ===================== LOAD CATS + STOCKS INIT ===================== */
  React.useEffect(() => {
    (async () => {
      try {
        const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks`;
        const { data } = await axios.get(url, buildAuthHeaders());
        const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
        const mapped = (list || [])
          .map((s) => ({
            id: s.stock_config_id ?? s.id,
            label: s.stock_config?.parametre ?? s.parametre ?? s.nom ?? s.name ?? s.label ?? "",
          }))
          .filter((x) => x.id && x.label && String(x.label).trim() !== "");
        setAllStocks(mapped);
      } catch (e) {
        console.error("[stocks] fetch failed:", e?.response?.data || e);
        setAllStocks([]);
      } finally {
        setLoadingStocks(false);
      }
    })();

    return () => {
      Object.values(debounceRefs.current || {}).forEach((t) => clearTimeout(t));
      debounceRefs.current = {};
    };
  }, [DOC_doctorId]);

  // click-away pour fermer les messages
  React.useEffect(() => {
    const onDocClick = () => {
      if (Date.now() - lastMsgAtRef.current < 150) return;
      setRowMsg({});
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  /* ===================== API SERVICES ===================== */
  const mapServerService = (r) => ({
    id: r.id,
    label: r.nom ?? "",
    origLabel: r.nom ?? "",
    editMode: false,
    snapshot: null,
    type: r.type ?? "interne",
    // garder en string pour éviter le 0 lors de la saisie
    prix: r.prix != null ? String(r.prix) : "",
    is_utilisable: !!r.is_utilisable,
    lockName: !!r.is_utilisable,

    stock1: "", q1: "",
    stock2: "", q2: "",
    stock3: "", q3: "",
    stock4: "", q4: "",
    stockId1: null, stockId2: null, stockId3: null, stockId4: null,
    categorie: "",
    searchExam: "",
    qte: toInt(r.qte ?? 1, 1),
  });

  async function loadRows() {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services`;
    const { data } = await axios.get(url, buildAuthHeaders());
    const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    const incoming = (list || []).map(mapServerService);
    setRows((prev) => (prev.length ? mergeStableOrder(prev, incoming) : incoming));
  }

  // Hydratation auto des stocks
  React.useEffect(() => {
    if (!DOC_doctorId || !rows?.length) return;
    const idsToHydrate = rows
      .map((r) => Number(r.id))
      .filter((id) => Number.isFinite(id) && id > 0 && !hydratedSet.current.has(id));
    if (!idsToHydrate.length) return;
    (async () => {
      for (const sid of idsToHydrate) {
        try {
          await hydrateRowStocks(sid, sid);
          hydratedSet.current.add(sid);
        } catch (e) {
          console.error("[stocks] hydrate failed for service", sid, e?.response?.data || e);
        }
      }
    })();
  }, [rows, DOC_doctorId]);

  function buildItemsFromRow(row) {
    const pairs = [1, 2, 3, 4]
      .map((i) => ({
        id: toInt(row[`stockId${i}`] ?? 0, 0),
        qt: toInt(row[`q${i}`] ?? 0, 0),
      }))
      .filter((p) => p.id > 0 && p.qt > 0);

    const sum = new Map();
    for (const { id, qt } of pairs) sum.set(id, (sum.get(id) ?? 0) + qt);

    return Array.from(sum.entries()).map(([id, qt]) => ({
      stock_config_id: id,
      quantite: qt,
    }));
  }

  async function saveRowStocks(serviceId, row) {
    if (row.type !== "interne") return;
    const items = buildItemsFromRow(row);
    
    // ⚠️ IMPORTANT: Ne pas appeler replaceServiceStocks si le tableau est vide
    // Cela évite d'effacer les stocks existants lors d'une simple édition du service.
    // Les stocks ajoutés via /stocks/add doivent persister même si on ne les affiche pas.
    if (!items.length) {
      console.log(`[saveRowStocks] Aucun stock à sauver pour le service ${serviceId} - skipping replaceServiceStocks`);
      return;
    }
    
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/${serviceId}/stocks`;
    await axios.post(url, { items }, buildAuthHeaders());
  }

  async function addOneStock(serviceId, stockId, qty) {
    if (!DOC_doctorId || !serviceId || !stockId || qty <= 0) return;
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/${serviceId}/stocks/add`;
    await axios.post(url, { stock_config_id: stockId, quantite: qty }, buildAuthHeaders());
  }
  async function addOneFromRow(row, idx) {
    if (Number.isNaN(Number(row.id)) || Number(row.id) <= 0) return;
    const stockId = toInt(row[`stockId${idx}`] ?? 0, 0);
    const qty = toInt(row[`q${idx}`] ?? 0, 0);
    if (!stockId || !qty) return;
    await addOneStock(Number(row.id), stockId, qty);
    await hydrateRowStocks(row.id, Number(row.id));
  }
  async function deleteOneStock(serviceId, stockId) {
    if (!DOC_doctorId || !serviceId || !stockId) return;
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/${serviceId}/stocks/${stockId}`;
    await axios.delete(url, buildAuthHeaders());
  }
  async function removeOneFromRow(row, idx) {
    if (Number.isNaN(Number(row.id)) || Number(row.id) <= 0) return;
    const stockId = toInt(row[`stockId${idx}`] ?? 0, 0);
    if (!stockId) return;
    await deleteOneStock(Number(row.id), stockId);
    await hydrateRowStocks(row.id, Number(row.id));
  }

  async function hydrateRowStocks(rowKeyOrNewId, serviceId) {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/${serviceId}/stocks`;
    const { data } = await axios.get(url, buildAuthHeaders());
    const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    const first4 = (list || []).slice(0, 4);

    setRows((prev) =>
      prev.map((x) => {
        if (x.id !== rowKeyOrNewId && x.id !== serviceId) return x;
        const nx = { ...x };
        for (let i = 1; i <= 4; i++) {
          nx[`stock${i}`] = "";
          nx[`q${i}`] = "";
          nx[`stockId${i}`] = null;
        }
        first4.forEach((it, i) => {
          const n = i + 1;
          nx[`stock${n}`] = it.nom ?? "";
          nx[`q${n}`] = String(it.quantite ?? "");
          nx[`stockId${n}`] = it.stock_config_id ?? it.id ?? null;
        });
        return nx;
      })
    );
  }

  // helper message
  const showLockedNameMsg = (rowId) => {
    lastMsgAtRef.current = Date.now();
    setRowMsg((m) => ({
      ...m,
      [rowId]: "",
    }));
  };

  // ====== EDIT MODE (row) ======
  const beginEditRow = (id) => {
    setRows((r) =>
      r.map((x) =>
        x.id === id
          ? {
              ...x,
              editMode: true,
              snapshot: {
                label: x.label,
                type: x.type,
                prix: x.prix,
                q1: x.q1, q2: x.q2, q3: x.q3, q4: x.q4,
                stock1: x.stock1, stock2: x.stock2, stock3: x.stock3, stock4: x.stock4,
                stockId1: x.stockId1, stockId2: x.stockId2, stockId3: x.stockId3, stockId4: x.stockId4,
              },
            }
          : x
      )
    );
    setFocusId(id);
  };

  const cancelEditRow = (id) => {
    setRows((r) =>
      r.map((x) =>
        x.id === id
          ? {
              ...x,
              editMode: false,
              ...(x.snapshot ? { ...x.snapshot } : {}),
              snapshot: null,
              label: x.lockName ? x.origLabel : x.label,
            }
          : x
      )
    );
    setRowMsg((m) => {
      const nm = { ...m };
      delete nm[id];
      return nm;
    });
  };

  // --- util: normaliser pour l'API (undefined si vide ou invalide)
  const normalizePriceForApi = (v) => {
    const s = String(v ?? "").replace(",", ".").trim();
    if (!s) return undefined;
    const n = Number(s);
    if (!Number.isFinite(n)) return undefined;
    return Math.max(0, Math.round(n * 100) / 100);
  };

  // ===== SAVE (create/update)
  async function saveRow(row) {
    if (!DOC_doctorId) return;

    const nom = (row.label || "").trim();
    if (!nom) {
      setRowMsg((m) => ({ ...m, [row.id]: "Le nom est requis." }));
      return;
    }

    const payload = {
      ...(row.id && !isNaN(Number(row.id)) ? { id: row.id } : {}),
      nom,
      type: row.type === "externe" ? "externe" : "interne",
      qte: sumQte(row),
    };

    const p = normalizePriceForApi(row.prix);
    if (p !== undefined) payload.prix = p;

    try {
      setRowMsg((m) => ({ ...m, [row.id]: "" }));
      setSavingRow((m) => ({ ...m, [row.id]: true }));

      const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/save`;
      const { data } = await axios.post(url, payload, buildAuthHeaders());
      const saved = data?.data || data;
      const serviceId = Number(saved?.id ?? row.id);
      const oldRowKey = row.id;

      setRows((prev) =>
        prev.map((x) =>
          x.id === oldRowKey
            ? {
                ...x,
                id: serviceId,
                label: saved?.nom ?? x.label,
                origLabel: saved?.nom ?? x.label,
                editMode: false,
                snapshot: null,
                type: saved?.type ?? x.type,
                qte: toInt(saved?.qte ?? x.qte, 1),
                prix: saved?.prix != null ? String(saved.prix) : (x.prix ?? ""),
                is_utilisable: !!saved?.is_utilisable,
                lockName: !!saved?.is_utilisable,
              }
            : x
        )
      );

      await saveRowStocks(serviceId, row);
      await hydrateRowStocks(oldRowKey, serviceId);
      hydratedSet.current.add(serviceId);

      setRowMsg((m) => {
        const nm = { ...m };
        delete nm[oldRowKey];
        delete nm[serviceId];
        return nm;
      });
    } catch (e) {
      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.errors?.nom?.[0] ||
        e?.response?.data?.errors?.[0] ||
        "Enregistrement impossible.";

      setRowMsg((m) => ({ ...m, [row.id]: String(msg) }));

      if (/déjà utilisé|deja utilise|vous ne pouvez pas|ne pouvez pas modifier son nom/i.test(msg)) {
        setRows((prev) =>
          prev.map((x) =>
            x.id === row.id
              ? { ...x, label: x.origLabel, lockName: true, editMode: false, snapshot: null }
              : x
          )
        );
      }

      console.error("[services] save failed:", e?.response?.data || e);
    } finally {
      setSavingRow((m) => ({ ...m, [row.id]: false }));
    }
  }

  /* ===================== UI HELPERS ===================== */
  const addRow = () => {
    const id = cryptoRandom();
    setRows((r) => [
      {
        id,
        label: "",
        origLabel: "",
        editMode: true,
        snapshot: null,
        type: "interne",
        prix: "",
        is_utilisable: false,
        lockName: false,

        stock1: "", q1: "",
        stock2: "", q2: "",
        stock3: "", q3: "",
        stock4: "", q4: "",
        stockId1: null, stockId2: null, stockId3: null, stockId4: null,
        categorie: "",
        searchExam: "",
        qte: 1,
      },
      ...r,
    ]);
    setFocusId(id);
    setNameFocusedId(id);
  };

  const removeRow = async (id) => {
    if (Number.isNaN(Number(id)) || Number(id) <= 0) {
      setRows((r) => r.filter((x) => x.id !== id));
      return;
    }

    if (!window.confirm("Archiver ce service ?")) return;

    try {
      const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services/${id}`;
      await axios.delete(url, buildAuthHeaders());

      Object.keys(debounceRefs.current || {}).forEach((k) => {
        if (k === String(id) || k.startsWith(`${id}|`)) {
          clearTimeout(debounceRefs.current[k]);
          delete debounceRefs.current[k];
        }
      });
      setSuggestions((s) => {
        const ns = { ...s };
        Object.keys(ns).forEach((k) => {
          if (k === String(id) || k.startsWith(`${id}|`)) delete ns[k];
        });
        return ns;
      });
      setLoadingRow((m) => { const nm = { ...m }; delete nm[id]; return nm; });
      setSavingRow((m) => { const nm = { ...m }; delete nm[id]; return nm; });
      setRowMsg((m) => { const nm = { ...m }; delete nm[id]; return nm; });

      setRows((r) => r.filter((x) => x.id !== id));
    } catch (e) {
      console.error("[services] delete/archive failed:", e?.response?.data || e);
      setRowMsg((m) => ({
        ...m,
        [id]: e?.response?.data?.message || "Impossible d'archiver ce service.",
      }));
    }
  };

  const update = (id, key, val) =>
    setRows((r) => r.map((x) => (x.id === id ? { ...x, [key]: val } : x)));

  const setType = (id, type) => {
    setRows((r) =>
      r.map((x) =>
        x.id === id
          ? x.editMode
            ? {
                ...x,
                type,
                // Sauvegarder le prix quand on passe à externe, restaurer quand on revient à interne
                ...(type === "externe"
                  ? {
                      // Sauvegarder le prix courant avant de le vider
                      prixSavedBeforeExterne: x.prix,
                      prix: "",
                      stock1: "", q1: "",
                      stock2: "", q2: "",
                      stock3: "", q3: "",
                      stock4: "", q4: "",
                      stockId1: null, stockId2: null, stockId3: null, stockId4: null,
                    }
                  : type === "interne"
                    ? {
                        // Restaurer le prix sauvegardé quand on repasse à interne
                        prix: x.prixSavedBeforeExterne || x.prix,
                        prixSavedBeforeExterne: undefined,
                      }
                    : {}),
              }
            : x
          : x
      )
    );
  };

  // ---------- recherche examens (label) ----------
  async function fetchAllProtocolExamsAcrossCats(query, cats) {
    const q = (query || "").trim();
    if (!q) return [];
    try {
      const batches = await Promise.all(
        (cats || []).map((c) => fetchProtocolExamsByCategory(c, q).catch(() => []))
      );
      const flat = [].concat(...batches);
      const seen = new Set();
      return flat.filter((x) => {
        const key = x.id ?? `${x.label}|${x.prix ?? ""}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    } catch (e) {
      console.error("[protocols] fetch all (across cats) failed:", e);
      return [];
    }
  }

  const onChangeLabel = (row, val) => {
    if (!row.editMode) return;

    setRowMsg((m) => ({ ...m, [row.id]: "" }));
    update(row.id, "label", val);

    if (debounceRefs.current[row.id]) clearTimeout(debounceRefs.current[row.id]);
    debounceRefs.current[row.id] = setTimeout(async () => {
      if (nameFocusedId !== row.id) return;
      setLoadingRow((m) => ({ ...m, [row.id]: true }));
      const list = await fetchAllProtocolExamsAcrossCats(val, categories);
      setSuggestions((s) => ({ ...s, [row.id]: list }));
      setLoadingRow((m) => ({ ...m, [row.id]: false }));
    }, 300);
  };

  const onChangeStock = (row, idx, val) => {
    if (!row.editMode || row.type !== "interne") return;
    update(row.id, `stock${idx}`, val);
    setNameFocusedId(null);
    setSuggestions((s) => ({ ...s, [row.id]: [] }));
  };

  const applyStockToRow = (rowId, idx, stock) => {
    setRows((r) =>
      r.map((x) =>
        x.id === rowId
          ? x.editMode && x.type === "interne"
            ? {
                ...x,
                [`stock${idx}`]: stock.label,
                [`stockId${idx}`]: stock.id,
                // NE PAS forcer à "1" - laisser l'utilisateur modifier
                // [`q${idx}`]: x[`q${idx}`] === "" || x[`q${idx}`] == null ? "1" : x[`q${idx}`],
              }
            : x
          : x
      )
    );
    setSuggestions((s) => ({ ...s, [keyStock(rowId, idx)]: [] }));
  };

  const closeStockSuggestions = (rowId, idx) => {
    setSuggestions((s) => ({ ...s, [keyStock(rowId, idx)]: [] }));
  };

  /* ===================== LOAD SERVICES INIT ===================== */
  React.useEffect(() => {
    if (!DOC_doctorId) return;
    loadRows().catch((e) => console.error("[services] load failed:", e));
  }, [DOC_doctorId]);

  /* ===================== RENDER ===================== */
  return (
    <div className="Card">
      <div className="CardHead">
        <span>Liste des services</span>
        <div className="HeadActions">
          <button className="Btn" type="button" onClick={addRow}>
            Ajouter
          </button>
        </div>
      </div>

      <div className="Rows rows-left">
        {rows.map((row) => {
          const isInterne = row.type === "interne";
          const rowSugs = suggestions[row.id] || [];
          const rowLoading = !!loadingRow[row.id];
          const isSaving = !!savingRow[row.id];
          const msg = rowMsg[row.id];

          // La quantité est modifiable si en mode édition et service interne
          const isQtyEditable = (n) => {
            return row.editMode && isInterne;
          };

          return (
            <div className="SrvRow" key={row.id} style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {/* Nom */}
              <div className="RelBox" style={{ position: "relative", flex: 1 }}>
                <input
                  className="Input md"
                  value={row.label}
                  onChange={(e) => onChangeLabel(row, e.target.value)}
                  placeholder="Nom service (taper pour chercher… en mode édition)"
                  aria-label="Nom du service"
                  readOnly={!row.editMode}
                  title={row.lockName ? "Attention: ce service est déjà utilisé, le serveur peut refuser le renommage lors de l'enregistrement." : undefined}
                  onFocus={() => setNameFocusedId(row.id)}
                  onBlur={() => setTimeout(() => setNameFocusedId(null), 0)}
                  ref={(el) => {
                    if (el && focusId === row.id) {
                      try {
                        el.focus();
                        const L = el.value?.length ?? 0;
                        el.setSelectionRange(L, L);
                      } catch {}
                      setFocusId(null);
                    }
                  }}
                />

                {/* Panneau de suggestions visible UNIQUEMENT si le champ Nom est focus */}
                {nameFocusedId === row.id && (rowLoading || (row.editMode && rowSugs.length > 0)) && (
                  <div className="SuggestPanel" style={{ position: "absolute", top: "55%", left: 0, right: 0 }}>
                    {rowLoading && <div className="SuggestItem muted">Recherche…</div>}
                    {!rowLoading &&
                      row.editMode &&
                      rowSugs.map((s) => (
                        <button
                          type="button"
                          key={s.id ?? `${s.label}|${s.prix ?? ""}`}
                          className="SuggestItem"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => {
                            if (!row.editMode) return;
                            setRows((r) =>
                              r.map((x) =>
                                x.id === row.id
                                  ? {
                                      ...x,
                                      label: s.label ?? x.label,
                                      prix: s.prix != null ? String(s.prix) : x.prix,
                                      ...(x.type === "externe"
                                        ? {
                                            stock1: "", q1: "",
                                            stock2: "", q2: "",
                                            stock3: "", q3: "",
                                            stock4: "", q4: "",
                                            stockId1: null, stockId2: null, stockId3: null, stockId4: null,
                                          }
                                        : {}),
                                    }
                                  : x
                              )
                            );
                            setSuggestions((sg) => ({ ...sg, [row.id]: [] }));
                            setNameFocusedId(null);
                          }}
                          title={s.prix ? `Tarif: ${s.prix}` : undefined}
                        >
                          <div className="si-title">{s.label}</div>
                          {s.prix !== undefined && s.prix !== null && s.prix !== "" && (
                            <div className="si-sub">Prix: {s.prix}</div>
                          )}
                        </button>
                      ))}
                    {!rowLoading && row.editMode && rowSugs.length === 0 && !!row.label?.trim() && (
                      <div className="SuggestItem muted">Aucun résultat</div>
                    )}
                  </div>
                )}

                {msg && (
                  <div className="RowMsg" style={{ marginTop: 4, fontSize: 12, color: "#b91c1c" }}>
                    {msg}
                  </div>
                )}
              </div>

              {/* Interne / Externe */}
              <div className="Segment" role="tablist" aria-label="Type de service" style={{ alignSelf: "flex-start", marginRight: 8 }}>
                <button
                  type="button"
                  role="tab"
                  aria-selected={isInterne}
                  className={`SegBtn ${isInterne ? "is-active" : ""}`}
                  onClick={() => row.editMode && setType(row.id, "interne")}
                  disabled={!row.editMode}
                  title={!row.editMode ? "Passez en mode édition pour changer le type" : undefined}
                  onFocus={() => { setNameFocusedId(null); setSuggestions((s) => ({ ...s, [row.id]: [] })); }}
                >
                  Interne
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={!isInterne}
                  className={`SegBtn ${!isInterne ? "is-active" : ""}`}
                  onClick={() => row.editMode && setType(row.id, "externe")}
                  disabled={!row.editMode}
                  title={!row.editMode ? "Passez en mode édition pour changer le type" : undefined}
                  onFocus={() => { setNameFocusedId(null); setSuggestions((s) => ({ ...s, [row.id]: [] })); }}
                >
                  Externe
                </button>
              </div>

              {/* Prix — éditable en mode édition et uniquement pour services internes */}
              <input
                className="Input sm"
                type="text"
                inputMode="decimal"
                value={row.prix ?? ""}
                onChange={(e) => row.editMode && isInterne && update(row.id, "prix", e.target.value)}
                onFocus={() => { setNameFocusedId(null); setSuggestions((s) => ({ ...s, [row.id]: [] })); }}
                placeholder="Prix"
                aria-label="Prix"
                disabled={!row.editMode || !isInterne}
                title={!row.editMode ? "Passez en mode édition pour modifier" : !isInterne ? "Prix uniquement pour les services internes" : undefined}
              />

              {/* Stocks 1..4 + quantités */}
              {[1,2, 3].map((n) => (
                <div key={n} style={{ display: "flex", alignItems: "center", gap:0, justifyContent: "space-between", flex: "0 0 160px" }}>
                  <div className="RelBox" style={{ position: "relative" }}>
                    <div className={`Select xs ${!row.editMode || !isInterne ? "is-disabled" : ""}`}>
                      <select style={{width:"100%"}}
                        className="Select-input"
                        value={(row[`stockId${n}`] != null ? row[`stockId${n}`] : "")}
                        onFocus={() => { setNameFocusedId(null); setSuggestions((s) => ({ ...s, [row.id]: [] })); }}
                        onChange={(e) => {
                          if (!row.editMode || !isInterne) return;
                          const id = Number(e.target.value) || null;
                          const st = (allStocks || []).find(s => String(s.id) === String(id));
                          setRows((r) =>
                            r.map((x) =>
                              x.id === row.id
                                ? {
                                    ...x,
                                    [`stockId${n}`]: id,
                                    [`stock${n}`]: st ? st.label : "",
                                    // NE PAS forcer la quantité à "1" - laisser l'utilisateur modifier
                                    // [`q${n}`]: (x[`q${n}`] === "" || x[`q${n}`] == null) ? "1" : x[`q${n}`],
                                  }
                                : x
                            )
                          );
                        }}
                        disabled={!row.editMode || !isInterne}
                        aria-label={`Stock utilisé ${n}`}
                        title={!row.editMode ? "Passez en mode édition pour modifier" : !isInterne ? "Stocks uniquement pour les services internes" : undefined}
                      >
                        <option value="">
                          {loadingStocks ? "Chargement…" : "—stock —"}
                        </option>
                        {(allStocks || []).map((s) => (
                          <option key={s.id} value={s.id}>{s.label}</option>
                        ))}
                      </select>
                      <span className="Select-arrow" aria-hidden="true" />
                    </div>
                  </div>

                  <div className="QtyWrap">
                    <input
                      className={`Input xxs QtyInput ${!isQtyEditable(n) ? "is-disabled" : ""}`}
                      type="number"
                      min={0}
                      step={1}
                      value={(row[`q${n}`] != null ? row[`q${n}`] : "")}
                      onFocus={() => { setNameFocusedId(null); setSuggestions((s) => ({ ...s, [row.id]: [] })); }}
                      onChange={(e) => {
                        if (!isQtyEditable(n)) return;
                        const v = e.target.value;
                        const nVal = v === "" ? "" : String(Math.max(0, Number.isFinite(+v) ? Math.trunc(+v) : 0));
                        update(row.id, `q${n}`, nVal);
                      }}
                      placeholder="Qt"
                      aria-label={`Quantité ${n}`}
                      disabled={!isQtyEditable(n)}
                      title={!isQtyEditable(n) ? 
                        (row.editMode ? 
                          "Uniquement pour les services internes" : 
                          "Passez en mode édition pour modifier") : 
                        "Modifier la quantité"}
                      style={{
                        opacity: isQtyEditable(n) ? 1 : 0.6,
                        cursor: isQtyEditable(n) ? "text" : "not-allowed",
                        backgroundColor: isQtyEditable(n) ? "white" : "#f9f9f9"
                      }}
                    />
                  </div>
                </div>
              ))}

              {/* === ACTIONS === */}
              <button
                className="IconBtn danger"
                onClick={() => removeRow(row.id)}
                aria-label="Supprimer"
                style={{ marginLeft: 6 }}
                title="Archiver ce service"
              >
                ✖
              </button>

              {!row.editMode && (
                <button
                  type="button"
                  className="IconBtn"
                  title="Modifier cette ligne"
                  onClick={() => beginEditRow(row.id)}
                  style={{ marginLeft: 4 }}
                >
                  ✎
                </button>
              )}
              {row.editMode && (
                <>
                  <button
                    type="button"
                    className="IconBtn"
                    title={!row.label?.trim() ? "Nom requis" : "Enregistrer cette ligne"}
                    onClick={() => saveRow(row)}
                    disabled={isSaving || !row.label?.trim()}
                    style={{ marginLeft: 4, opacity: isSaving ? 0.9 : 1 }}
                  >
                    {isSaving ? "⏳" : "💾"}
                  </button>
                  <button
                    type="button"
                    className="IconBtn"
                    title="Annuler les modifications"
                    onClick={() => cancelEditRow(row.id)}
                    style={{ marginLeft: 4 }}
                  >
                    ↩
                  </button>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ---------- Onglet 2 : Stocks ---------- */
function Stocks() {
  const [items, setItems] = React.useState([]);
  const [adjust, setAdjust] = React.useState(null);
  const [showGlobalHistory, setShowGlobalHistory] = React.useState(false);
  const [savingId, setSavingId] = React.useState(null);
  const [confirmArchive, setConfirmArchive] = React.useState(null);

  const [globalHistory, setGlobalHistory] = React.useState([]);

  const DOC_doctorId = React.useMemo(getDoctorIdFromLoginInfo, []);

  // --- helpers ---
  const cryptoRandom = React.useMemo(
    () => () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );
  const isTempId = (id) => !id || isNaN(Number(id));

  const toNumber = (v, { clampMin = null } = {}) => {
    let s = v;
    if (typeof s === "string") s = s.replace(",", ".").trim();
    const n = Number(s);
    const ok = Number.isFinite(n) ? n : 0;
    return clampMin !== null ? Math.max(clampMin, ok) : ok;
  };

  const showApiError = (e, fallback = "Erreur serveur") => {
    const msg = e?.response?.data?.message;
    const errors = e?.response?.data?.errors;
    if (errors && typeof errors === "object") {
      const first = Object.values(errors)[0];
      if (Array.isArray(first) && first[0]) {
        alert(first[0]);
        return;
      }
    }
    alert(msg || fallback);
  };

  // formatteur demandé par le backend : "YYYY-MM-DD HH:mm:ss"
  const pad2 = (n) => String(n).padStart(2, "0");
  const formatServerDate = (d = new Date()) => {
    const date = new Date(d);
    const Y = date.getFullYear();
    const M = pad2(date.getMonth() + 1);
    const D = pad2(date.getDate());
    const h = pad2(date.getHours());
    const m = pad2(date.getMinutes());
    const s = pad2(date.getSeconds());
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  };

  // garder l’ordre + conserver les lignes temporaires
  const mergeStableOrder = (prev, incoming) => {
    const incMap = new Map(incoming.map((x) => [String(x.id), x]));
    const out = [];
    for (const p of prev) {
      const id = String(p.id);
      if (incMap.has(id)) {
        const srv = incMap.get(id);
        incMap.delete(id);
        out.push({ ...srv, isEditing: !!p.isEditing, isNew: !!p.isNew });
      } else if (isTempId(p.id) || p.isNew) {
        out.push(p);
      }
    }
    for (const rest of incMap.values()) out.push(rest);
    return out;
  };

  // Fallbacks
  const lastCreatedRef = React.useRef({});  // {[stockId]: {qty,cost,note,name}}
  const lastMoveRef = React.useRef({});     // {[stockId]: {qty,cost,note,date}}
  const pendingCreateRef = React.useRef({}); // {[tempId]: {qty,cost,note}}

  // Normaliser l’historique + déduire action + fallbacks
  const normalizeHistory = (rows) => {
    const arr = Array.isArray(rows) ? rows : [];
    return arr.map((h) => {
      const stockId = h.stock_config_id ?? h.stockConfigId ?? h.stock_id;
      // parsing robuste : if server gives "YYYY-MM-DD HH:mm:ss" -> replace space with T for Date parsing when needed
      const rawDate = h.operation_at ?? h.date ?? h.created_at ?? new Date().toISOString();
      const parseable = String(rawDate).includes("T") ? rawDate : String(rawDate).replace(" ", "T");
      const date = parseable;
      let qty  = toNumber(h.qnt  ?? h.qty   ?? h.delta ?? h.quantity ?? 0);
      let cost = toNumber(h.prix ?? h.price ?? h.cost  ?? 0, { clampMin: 0 });
      let note = h.note ?? h.remarque ?? "";
      let action = h.action || h.type || "";
      const stockName = h.stock_name ?? h.stockName ?? h.nom ?? "";

      const nlow = String(note).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      if (!action) {
        if (nlow.includes("archiv")) action = "Archivé";
        else if (nlow.includes("creation initiale")) action = "Création";
        else if (qty > 0) action = "Entrée";
        else if (qty < 0) action = "Sortie";
        else action = "—";
      }

      // Fallback création (si back renvoie 0/0/note vide)
      if (action === "Création" && qty === 0 && cost === 0 && !note) {
        const fixC = lastCreatedRef.current?.[String(stockId)];
        if (fixC) {
          qty = toNumber(fixC.qty);
          cost = toNumber(fixC.cost, { clampMin: 0 });
          note = fixC.note || "";
        }
      }

      // Fallback ajustement (match ≈ 5 minutes)
      const fixM = lastMoveRef.current?.[String(stockId)];
      if (fixM) {
        try {
          const d1 = new Date(String(date).replace(" ", "T")).getTime();
          const d2 = new Date(String(fixM.date).replace(" ", "T")).getTime();
          const dt = Math.abs(d1 - d2);
          if (dt < 5 * 60 * 1000) {
            if (cost === 0) cost = toNumber(fixM.cost, { clampMin: 0 });
            if (!note) note = fixM.note || "";
            if (qty === 0)  qty  = toNumber(fixM.qty);
          }
        } catch (e) {
          // ignore parse errors
        }
      }

      return {
        id: h.id ?? cryptoRandom(),
        stock_config_id: stockId,
        date,
        qty,
        cost,
        note,
        action,
        stockName,
      };
    });
  };

  const mapServerStock = (r) => ({
    id: r.stock_config_id ?? r.stockConfigId ?? r.id,
    name:
      r.stock_config?.parametre ?? r.stockConfig?.parametre ?? r.nom ?? r.name ?? "",
    dispo: toNumber(r.disponible ?? r.dispo ?? r.quantity ?? 0),
    seuil: toNumber(r.seuil ?? r.threshold ?? 0, { clampMin: 0 }),
    alert: !!(r.alert_enabled ?? r.alerte ?? r.alert),
    prix: r.prix ?? r.price ?? "",
    history: [],
    isEditing: false,
    isNew: false,
  });

  // --- API ---
  async function loadStocks() {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks`;
    const { data } = await axios.get(url, buildAuthHeaders());
    const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    const base = (list || []).map(mapServerStock);

    try {
      const hUrl = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/history?limit=1000`;
      const { data: hData } = await axios.get(hUrl, buildAuthHeaders());
      const rawHist = Array.isArray(hData?.data) ? hData.data : (Array.isArray(hData) ? hData : []);
      const hist = normalizeHistory(rawHist);

      const byStock = hist.reduce((acc, h) => {
        (acc[h.stock_config_id] ||= []).push(h);
        return acc;
      }, {});
      base.forEach((it) => {
        it.history = (byStock[it.id] || []).sort((a, b) => new Date(String(b.date).replace(" ", "T")) - new Date(String(a.date).replace(" ", "T")));
      });

      const histWithNames = hist.map((h) => ({
        ...h,
        stockName: h.stockName || base.find((x) => String(x.id) === String(h.stock_config_id))?.name || "—",
      }));
      setGlobalHistory(histWithNames.sort((a, b) => new Date(String(b.date).replace(" ", "T")) - new Date(String(a.date).replace(" ", "T"))));
    } catch (e) {
      console.warn("history fetch failed:", e?.response?.data || e);
    }

    setItems((prev) => mergeStableOrder(prev, base));
  }

  async function reloadHistory() {
    try {
      const hUrl = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/history?limit=1000`;
      const { data } = await axios.get(hUrl, buildAuthHeaders());
      const raw = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
      const hist = normalizeHistory(raw);
      setGlobalHistory(hist.sort((a, b) => new Date(String(b.date).replace(" ", "T")) - new Date(String(a.date).replace(" ", "T"))));
    } catch (e) {
      console.error("reloadHistory failed:", e?.response?.data || e);
    }
  }

  async function patchThreshold(stockId, seuil) {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/${stockId}/threshold`;
    return axios.patch(
      url,
      { seuil: Math.round(toNumber(seuil, { clampMin: 0 })) },
      { ...buildAuthHeaders(), headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
  }

  async function patchAlert(stockId, enabled) {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/${stockId}/alert`;
    return axios.patch(
      url,
      { enabled: !!enabled },
      { ...buildAuthHeaders(), headers: { "Content-Type": "application/json", Accept: "application/json" } }
    );
  }

  // N’envoie 'prix' que si saisi. Envoie operation_at au format demandé par le backend.
  async function moveStock(it, delta, rawCost, note) {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/move`;
    const qty = toNumber(delta);
    const hasCost =
      rawCost !== "" &&
      rawCost != null &&
      !Number.isNaN(Number(String(rawCost).replace(",", ".")));

    const payload = {
      stock_config_id: it.id,
      delta: qty,
      note: (note || "").trim(),
      ...(hasCost ? { prix: toNumber(rawCost, { clampMin: 0 }) } : {}),
      operation_at: formatServerDate(new Date()), // <-- format Y-m-d H:i:s
    };

    await axios.post(url, payload, {
      ...buildAuthHeaders(),
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    });
  }

  async function createStock(payload) {
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/save`;
    const payloadWithDate = { ...payload, operation_at: formatServerDate(new Date()) };
    const { data } = await axios.post(url, payloadWithDate, {
      ...buildAuthHeaders(),
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    });
    return data;
  }

  const isDuplicateName = (nom) => {
    const key = String(nom || "").trim().toLowerCase();
    if (!key) return false;
    return items.some(
      (x) =>
        !isTempId(x.id) &&
        String(x.name || "").trim().toLowerCase() === key
    );
  };

  // --- lifecycle ---
  React.useEffect(() => {
    if (!DOC_doctorId) return;
    loadStocks().catch((e) => console.error("fetchDoctorStocks failed", e));
  }, [DOC_doctorId]);

  // --- UI helpers ---
  const update = (id, key, val) =>
    setItems((xs) => xs.map((x) => (x.id === id ? { ...x, [key]: val } : x)));

  const add = () =>
    setItems((xs) => [
      {
        id: cryptoRandom(),
        name: "",
        dispo: 0,
        seuil: 0,
        alert: false,
        prix: "",
        history: [],
        isEditing: true,
        isNew: true,
      },
      ...xs,
    ]);

  const toggleRowEdit = (it) => {
    setItems((xs) =>
      xs.map((x) => (x.id === it.id ? { ...x, isEditing: !x.isEditing } : x))
    );
  };

  // ENREGISTRER (création ou update seuil/alerte)
  const saveRow = async (it) => {
    if (!DOC_doctorId) return;
    try {
      setSavingId(it.id);

      if (isTempId(it.id) && it.isNew) {
        const nom = (it.name || "").trim();
        if (!nom) {
          setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: true } : x)));
          alert("Le nom est requis.");
          return;
        }
        if (isDuplicateName(nom)) {
          setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: true } : x)));
          alert("Stock déjà existé.");
          return;
        }

        // ← récupère l’ajustement fait avant création (s’il existe)
        const pending = pendingCreateRef.current[it.id] || null;

        const payload = {
          nom,
          disponible: Math.round(toNumber(it.dispo)),
          seuil: Math.round(toNumber(it.seuil, { clampMin: 0 })),
          alert_enabled: !!it.alert,
          ...(pending && pending.cost != null
            ? { prix: toNumber(pending.cost, { clampMin: 0 }) }
            : it.prix !== "" && it.prix != null
              ? { prix: toNumber(it.prix, { clampMin: 0 }) }
              : {}), // n’envoie pas prix si vide
          write_history: true,
          note: pending && pending.note ? pending.note : "Création initiale",
        };

        let res;
        try {
          res = await createStock(payload);
        } catch (e) {
          const firstNomErr = e?.response?.data?.errors?.nom?.[0];
          if (firstNomErr) alert(firstNomErr);
          else showApiError(e, "Échec de la création.");
          setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: true } : x)));
          return;
        }

        const newId = String(
          res?.data?.stock_config?.id ??
          res?.stock_config?.id ??
          res?.data?.id ??
          res?.id ??
          ""
        );

        // Mémorise la création (fallback après reload)
        lastCreatedRef.current[String(newId)] = {
          qty: payload.disponible,
          cost: payload?.prix ?? 0,
          note: payload.note || "",
          name: nom,
        };
        delete pendingCreateRef.current[it.id];

        // Optimiste "Création" (date format server)
        const nowForServer = formatServerDate(new Date());
        setGlobalHistory((hs) => [
          {
            id: cryptoRandom(),
            stock_config_id: newId,
            date: nowForServer,
            qty: payload.disponible,
            cost: payload?.prix ?? 0,
            note: payload.note || "",
            action: "Création",
            stockName: nom,
          },
          ...hs,
        ]);

        await loadStocks();

        setItems((xs) => {
          const filtered = xs.filter((x) => !(x.isNew && (x.name || "").trim() === nom));
          return filtered.map((x) =>
            String(x.id) === newId ? { ...x, isNew: false, isEditing: false } : x
          );
        });
      } else {
        try {
          await Promise.all([patchThreshold(it.id, it.seuil), patchAlert(it.id, it.alert)]);
        } catch (e) {
          showApiError(e, "Échec de la mise à jour.");
          setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: true } : x)));
          return;
        }
        await loadStocks();
        setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: false } : x)));
      }
    } catch (e) {
      console.error("saveRow failed:", e?.response?.data || e);
      showApiError(e, "Échec de l’enregistrement.");
      setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: true } : x)));
    } finally {
      setSavingId(null);
    }
  };

  const onBlurSeuil = async (it) => {
    if (!DOC_doctorId || isTempId(it.id) || it.isNew) return;
    try {
      await patchThreshold(it.id, it.seuil);
      await loadStocks();
    } catch (e) {
      showApiError(e, "Échec de la mise à jour du seuil.");
    }
  };

  const toggleAlert = async (it) => {
    const next = !it.alert;
    update(it.id, "alert", next);
    if (!DOC_doctorId || isTempId(it.id) || it.isNew) return;
    try {
      const { data } = await patchAlert(it.id, next);
      const serverVal = typeof data?.alert_enabled === "boolean" ? data.alert_enabled : next;
      update(it.id, "alert", serverVal);
      await loadStocks();
    } catch (e) {
      showApiError(e, "Échec de la mise à jour de l’alerte.");
      update(it.id, "alert", !next);
    }
  };

  const openAdjustForm = (it) => {
    setAdjust({ id: it.id, name: it.name || "", qty: "", cost: "", note: "" });
  };

  const submitAdjust = async () => {
    if (!adjust) return;
    const qty = toNumber(adjust.qty);
    const note = (adjust.note || "").trim();

    const rawCost = adjust.cost;
    const hasCost =
      rawCost !== "" &&
      rawCost != null &&
      !Number.isNaN(Number(String(rawCost).replace(",", ".")));
    const cost = hasCost ? toNumber(rawCost, { clampMin: 0 }) : 0;

    try {
      const target = items.find((x) => x.id === adjust.id);
      const isNewRow = !target || isTempId(target.id) || target.isNew;
      const stockIdKey = String(target?.id ?? adjust.id);
      const nowForServer = formatServerDate(new Date());

      // Mémorise l’ajustement pour fallback ET pour création si ligne nouvelle
      lastMoveRef.current[stockIdKey] = { qty, cost: hasCost ? cost : 0, note, date: nowForServer };
      if (isNewRow) {
        pendingCreateRef.current[adjust.id] = { qty, cost: hasCost ? cost : 0, note };
      }

      // Historique optimiste (date format serveur)
      setGlobalHistory((hs) => [
        {
          id: cryptoRandom(),
          stock_config_id: target?.id ?? adjust.id,
          date: nowForServer,
          qty,
          cost: hasCost ? cost : 0,
          note,
          action: qty >= 0 ? "Entrée" : "Sortie",
          stockName: target?.name || adjust.name || "—",
        },
        ...hs,
      ]);

      if (isNewRow) {
        setItems((xs) =>
          xs.map((x) =>
            x.id === adjust.id
              ? {
                  ...x,
                  dispo: toNumber(x.dispo) + qty,
                  history: [{ id: cryptoRandom(), date: nowForServer, qty, cost: hasCost ? cost : 0, note }, ...(x.history || [])],
                }
              : x
          )
        );
      } else {
        await moveStock(target, qty, hasCost ? cost : undefined, note);
        setItems((xs) =>
          xs.map((x) =>
            x.id === adjust.id
              ? {
                  ...x,
                  dispo: toNumber(x.dispo) + qty,
                  history: [{ id: cryptoRandom(), date: nowForServer, qty, cost: hasCost ? cost : 0, note }, ...(x.history || [])],
                }
              : x
          )
        );
        await loadStocks();
      }
    } catch (e) {
      console.error("moveStock failed:", e?.response?.data || e);
      showApiError(e, "Échec de l’ajustement.");
    } finally {
      setAdjust(null);
    }
  };

  async function removeItem(it) {
    if (isTempId(it.id) || it.isNew) {
      setItems((xs) => xs.filter((x) => x.id !== it.id));
      return;
    }
    setConfirmArchive({ id: it.id, name: it.name || "—" });
  }

  async function doArchive(id, name) {
    try {
      const url = `${API_BASE_URL}doctor/${DOC_doctorId}/stocks/${id}`;
      await axios.delete(url, { ...buildAuthHeaders(), params: { archive: 1 } });

      setItems((xs) => xs.filter((x) => x.id !== id));

      setGlobalHistory((hs) => [
        {
          id: cryptoRandom(),
          stock_config_id: id,
          date: formatServerDate(new Date()),
          qty: 0,
          cost: 0,
          note: "",
          action: "Archivé",
          stockName: name || "—",
        },
        ...hs,
      ]);

      await reloadHistory();
    } catch (e) {
      console.error("archive stock failed:", e?.response?.data || e);
      showApiError(e, "Impossible d’archiver ce stock.");
    } finally {
      setConfirmArchive(null);
    }
  }

  // ----- Render -----
  return (
    <div className="tbk-stocks tbk-stocks--compact Card">
      <div className="CardHead tbk-stocks__head">
        <span className="tbk-stocks__title">Liste des stocks</span>
        <div className="tbk-stocks__actions">
          <button
            className="Btn Btn--dark tbk-stocks__btn"
            onClick={() => setShowGlobalHistory((v) => !v)}
            title="Afficher/Masquer l'historique global"
          >
            Historique
          </button>
          <button className="Btn tbk-stocks__btn" onClick={add}>
            <Plus size={16} /> Ajouter
          </button>
        </div>
      </div>

      <div className="StockHead">
        <div className="ColHead" />
        <div className="ColHead">Disponible</div>
        <div className="ColHead">Seuil alerte</div>
        <div />
      </div>

      {items.map((it) => {
        const isLow = !!it.alert && toNumber(it.dispo) < toNumber(it.seuil);
        const canEdit = !!it.isEditing;
        const isSaving = savingId === it.id;

        return (
          <div className="StockRow" key={it.id}>
            <input
              className="Input md StockName"
              value={it.name}
              onChange={(e) => (it.isNew && canEdit ? update(it.id, "name", e.target.value) : null)}
              readOnly={!it.isNew}
              placeholder={it.isNew ? "Nom du stock (obligatoire)" : "Nom du stock"}
              title={it.isNew ? "Saisissez le nom" : "Nom non modifiable"}
              style={{ cursor: it.isNew ? "text" : "not-allowed", background: it.isNew ? "#fff" : "#f8f8f8" }}
              disabled={!canEdit}
            />

            <div className="QtyCell">
              <input
                className={`Input xs${isLow ? " Input--danger" : ""}`}
                type="number"
                value={it.dispo}
                readOnly
                aria-invalid={isLow}
                title={isLow ? "Disponible sous le seuil (alerte activée)" : "Se modifie via “+”"}
                style={{ cursor: "not-allowed" }}
                disabled={!canEdit}
              />
              <button
                className="RoundBtn"
                type="button"
                title="Ajuster le stock (positif = entrée, négatif = sortie)"
                onClick={() => canEdit && openAdjustForm(it)}
                style={{ marginLeft: "5px" }}
              >
                +
              </button>
            </div>

            <div className="AlertCell">
              <input
                className="Input xs"
                type="number"
                value={it.seuil}
                onChange={(e) => canEdit && update(it.id, "seuil", e.target.value)}
                onBlur={() => canEdit && onBlurSeuil(it)}
                disabled={!canEdit}
                title={!canEdit ? "Cliquez d'abord sur l’icône Éditer" : undefined}
              />
              <button
                className={`Btn ${it.alert ? "" : "Btn--ghost"}`}
                onClick={() => canEdit && toggleAlert(it)}
                disabled={!canEdit}
              >
                <AlertTriangle size={16} />
                {it.alert ? "Alerte activée" : "Activer alerte"}
              </button>
            </div>

            <div className="RowActions" style={{ display: "flex", gap: 8 }}>
              {canEdit && (
                <button
                  className="IconBtn primary"
                  onClick={() => {
                    setItems((xs) => xs.map((x) => (x.id === it.id ? { ...x, isEditing: false } : x)));
                    saveRow(it);
                  }}
                  aria-label="Enregistrer"
                  title="Enregistrer"
                  disabled={isSaving}
                >
                  {isSaving ? "⏳" : "💾"}
                </button>
              )}

              <button
                className={`IconBtn ${canEdit ? "primary" : ""}`}
                onClick={() => toggleRowEdit(it)}
                aria-label="Éditer"
                title={canEdit ? "Quitter le mode édition" : "Passer en édition"}
                disabled={isSaving}
              >
                <Edit2 size={16} />
              </button>

              <button
                className="IconBtn danger"
                onClick={() => removeItem(it)}
                aria-label="Supprimer"
                title="Archiver ce stock"
                disabled={isSaving}
              >
                <X size={16} />
              </button>
            </div>
          </div>
        );
      })}

      {showGlobalHistory && (
        <div className="Hist Hist--global">
          {globalHistory.length === 0 ? (
            <div className="Empty">
              <h4>Aucun mouvement</h4>
              <p>Utilise le bouton “Éditer” puis “+” pour ajuster un stock.</p>
            </div>
          ) : (
            <div className="HistTable">
              <div className="HistHead">
                <span>Date</span>
                <span>Stock</span>
                <span>Quantité</span>
                <span>Coût (DA)</span>
                <span>Actions</span>
                <span>Note</span>
              </div>
              {globalHistory.map((h) => {
                const act = h.action || "—";
                const actIcon =
                  act === "Archivé" ? "🗑️" :
                  act === "Création" ? "✨" :
                  h.qty > 0 ? "➕" :
                  h.qty < 0 ? "➖" : "•";

                return (
                  <div className="HistRow" key={h.id}>
                    <span>{String(h.date).replace("T", " ")}</span>
                    <span>{h.stockName || "—"}</span>
                    <span className={h.qty >= 0 ? "pos" : "neg"}>{h.qty >= 0 ? `+${h.qty}` : h.qty}</span>
                    <span>{toNumber(h.cost).toLocaleString()}</span>
                    <span>{actIcon} {act}</span>
                    <span>{h.note || "—"}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {adjust ? (
        <div className="PopWrap">
          <div className="PopBackdrop" onClick={() => setAdjust(null)} />
          <div
            className="PopCard"
            role="dialog"
            aria-modal="true"
            tabIndex={-1}
            onKeyDown={(e) => {
              if (e.key === "Enter") submitAdjust();
              if (e.key === "Escape") setAdjust(null);
            }}
          >
            <div className="PopHead">
              <strong>Ajuster le stock — {adjust.name}</strong>
              <button className="IconBtn" onClick={() => setAdjust(null)} title="Fermer">
                <X size={16} />
              </button>
            </div>
            <div className="PopBody">
              <div className="Row">
                <div className="FField">
                  <input
                    className="Input md"
                    type="text"
                    inputMode="numeric"
                    value={adjust.qty}
                    onChange={(e) => setAdjust((a) => ({ ...a, qty: e.target.value }))}
                    placeholder="Quantité (ex: 5 ou -3)"
                  />
                </div>
                <div className="FField">
                  <input
                    className="Input md"
                    type="text"
                    inputMode="decimal"
                    value={adjust.cost}
                    onChange={(e) => setAdjust((a) => ({ ...a, cost: e.target.value }))}
                    placeholder="Coût total en DA"
                  />
                </div>
              </div>
              <input
                className="Input fill"
                value={adjust.note}
                onChange={(e) => setAdjust((a) => ({ ...a, note: e.target.value }))}
                placeholder="Note (n° facture, fournisseur…)"
              />
              <div className="Hint">Astuce : nombre positif = entrée, négatif = sortie.</div>
            </div>
            <div className="PopFoot">
              <button className="Btn Btn--ghost" onClick={() => setAdjust(null)}>
                Annuler
              </button>
              <button className="Btn" onClick={submitAdjust}>
                Valider
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {confirmArchive ? (
        <div className="PopWrap">
          <div className="PopBackdrop" onClick={() => setConfirmArchive(null)} />
          <div className="PopCard" role="dialog" aria-modal="true" tabIndex={-1}>
            <div className="PopHead">
              <strong>Archiver le stock</strong>
              <button className="IconBtn" onClick={() => setConfirmArchive(null)} title="Fermer">
                <X size={16} />
              </button>
            </div>
            <div className="PopBody">
              <p>Voulez-vous vraiment archiver <b>{confirmArchive.name}</b> ?</p>
              <p style={{fontSize:12, color:"#6b7280"}}>L’élément restera consultable dans l’historique.</p>
            </div>
            <div className="PopFoot">
              <button className="Btn Btn--ghost" onClick={() => setConfirmArchive(null)}>
                Annuler
              </button>
              <button className="Btn danger" onClick={() => doArchive(confirmArchive.id, confirmArchive.name)}>
                Archiver
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
/* ---------- Onglet 3 : Indices / Charts ---------- */

function IndicesCharts() {
  const doctorId = getDoctorIdFromLoginInfo();

  const [q, setQ] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [savingRows, setSavingRows] = React.useState({});
  const [editingRows, setEditingRows] = React.useState({});
  const [allCharts, setAllCharts] = React.useState([]);
  const [suggestions, setSuggestions] = React.useState([]);
  const [activeEditingId, setActiveEditingId] = React.useState(null);
  const searchBarRef = React.useRef(null);

  const cryptoRandom = React.useCallback(
    () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
        setQ("");
      }
    };
    if (q) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [q]);

  // Charger les données
  React.useEffect(() => {
    if (!doctorId) return;

    const loadData = async () => {
      try {
        setLoading(true);

        const list = await fetchChartsssList(doctorId);
        setRows(
          (list || []).map((r) => ({
            id: r.id ?? cryptoRandom(),
            label: r.parametre || r.nom || "",
            unit: r.unite || "",
            min: r.valeur_min ?? "",
            max: r.valeur_max ?? "",
            duplicate: false,
            fromDropdown: false,
            inDb: false,
          }))
        );

        const all = await fetchChartsList();
        setAllCharts(all || []);
      } catch (e) {
        console.error("[charts] fetch failed:", e);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [doctorId, cryptoRandom]);

  const update = (id, k, v) => {
    setRows((r) => r.map((x) => (x.id === id ? { ...x, [k]: v } : x)));
  };

  // Vérifier doublon dans la liste actuelle ET dans allCharts
  const checkDuplicateAndInDb = (id, value) => {
    const trimmedValue = value.trim().toLowerCase();
    
    const duplicate = rows
      .filter((r) => r.id !== id)
      .some((r) => r.label.trim().toLowerCase() === trimmedValue);
    
    const inDb = allCharts.some(chart => 
      (chart.label || chart.parametre || chart.nom || "")
        .trim()
        .toLowerCase() === trimmedValue
    );
    
    setRows((r) => r.map((x) => 
      x.id === id ? { ...x, duplicate, inDb } : x
    ));
    
    return { duplicate, inDb };
  };

  // Gestion de la saisie
  const handleLabelChange = (id, value) => {
    update(id, "label", value);
    setActiveEditingId(id);
    setRows((r) => r.map((x) => 
      x.id === id ? { ...x, fromDropdown: false } : x
    ));

    if (!value.trim()) {
      setSuggestions([]);
      checkDuplicateAndInDb(id, value);
      return;
    }

    const filtered = allCharts.filter((chart) =>
      (chart.label || chart.parametre || chart.nom || "")
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setSuggestions(filtered);

    checkDuplicateAndInDb(id, value);
  };

  // Sélection depuis dropdown → TOUJOURS marquer comme inDb
  const selectSuggestion = (chart) => {
    if (!activeEditingId) return;

    const label = (chart.label || chart.parametre || chart.nom || "").trim();

    setRows((prev) =>
      prev.map((row) =>
        row.id === activeEditingId
          ? {
              ...row,
              label,
              unit: chart.unite || "",
              min: chart.valeur_min ?? "",
              max: chart.valeur_max ?? "",
              duplicate: false,
              inDb: true,
              fromDropdown: true,
            }
          : row
      )
    );

    setSuggestions([]);
  };

  // Ajouter en HAUT de la liste
  const add = () => {
    const newRow = {
      id: cryptoRandom(),
      label: "",
      unit: "",
      min: "",
      max: "",
      duplicate: false,
      fromDropdown: false,
      inDb: false,
    };
    setRows((r) => [newRow, ...r]);
    setEditingRows((prev) => ({ ...prev, [newRow.id]: true }));
    setActiveEditingId(newRow.id);
  };

  const remove = async (id) => {
    setRows((r) => r.filter((x) => x.id !== id));
    setEditingRows((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });

    if (!doctorId) return;
    try {
      if (Number.isInteger(id)) {
        await deleteChartsConfigApi(doctorId, id);
      }
      alert("Ligne supprimée !");
    } catch (e) {
      console.error("[charts] delete failed:", e);
      alert("Erreur suppression !");
    }
  };

  const saveRow = async (row) => {
    if (!doctorId || row.duplicate || row.inDb) {
      if (row.inDb) {
        alert("Impossible d'enregistrer : cet élément existe déjà dans le catalogue !");
      } else if (row.duplicate) {
        alert("Impossible d'enregistrer : cet élément existe déjà dans votre liste !");
      }
      return;
    }

    setSavingRows((prev) => ({ ...prev, [row.id]: true }));

    try {
      const payload = {
        parametre: row.label,
        unite: row.unit,
        minval: row.min,
        maxval: row.max,
      };

      if (Number.isInteger(row.id)) {
        await updateChartsConfigApi(doctorId, row.id, payload);
      } else {
        const res = await createChartsConfigApi(doctorId, payload);
        setRows((r) =>
          r.map((x) => (x.id === row.id ? { ...x, id: res.data.data.id } : x))
        );
      }
      setEditingRows((prev) => ({ ...prev, [row.id]: false }));
    } catch (e) {
      console.error("[charts] save failed:", e);
      alert("Erreur save !");
    } finally {
      setSavingRows((prev) => ({ ...prev, [row.id]: false }));
    }
  };

  const toggleEdit = (id) => {
    setEditingRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const normalize = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const filtered = React.useMemo(() => {
    const needle = normalize(q);
    if (!needle) return rows;
    
    // Cherche dans rows (données locales)
    const inRows = rows.filter((x) =>
      normalize(x.label).includes(needle) || normalize(x.unit).includes(needle)
    );
    
    // Cherche dans le catalogue (allCharts)
    const inCatalog = (allCharts || [])
      .filter((chart) =>
        normalize(chart.label || chart.parametre || chart.nom || "").includes(needle) ||
        normalize(chart.unite || "").includes(needle)
      )
      .map((chart) => ({
        id: `cat_${chart.id}`,
        label: chart.label || chart.parametre || chart.nom || "",
        unit: chart.unite || "",
        min: chart.valeur_min ?? "",
        max: chart.valeur_max ?? "",
        duplicate: false,
        fromDropdown: false,
        inDb: true,
        _highlight: true,
      }))
      .filter((item) =>
        !rows.some((r) => normalize(r.label) === normalize(item.label))
      );
    
    return [...inRows, ...inCatalog];
  }, [rows, q, allCharts]);

  if (!doctorId) return <div className="Empty">Doctor ID introuvable</div>;

  return (
    <div className="Card">
      <div className="CardHead">
        <span>Listes des indices pour les Charts</span>
        <button className="Btn" onClick={add}>
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="SearchBar" ref={searchBarRef}>
        <Search size={16} />
        <input
          className="Input md"
          placeholder="Search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />

        {/* Dropdown des résultats de recherche */}
        {q && filtered.length > 0 && (
          <div className="SearchDropdown">
            <div className="DropdownHeader">
              <strong style={{ fontSize: 12, color: "#666" }}>Résultats ({Math.min(filtered.length, 15)} / {filtered.length})</strong>
            </div>
            {filtered.slice(0, 15).map((result) => (
              <button
                key={result.id}
                type="button"
                className="DropdownItem"
                onClick={() => {
                  if (!result._highlight) {
                    setActiveEditingId(result.id);
                  } else {
                    // Ajouter depuis le catalogue
                    const newId = cryptoRandom();
                    const newRow = {
                      id: newId,
                      label: result.label,
                      unit: result.unit,
                      min: result.min,
                      max: result.max,
                      duplicate: false,
                      fromDropdown: true,
                      inDb: true,
                    };
                    setRows((r) => [newRow, ...r]);
                    setEditingRows((prev) => ({ ...prev, [newId]: true }));
                    setActiveEditingId(newId);
                    setQ("");
                  }
                }}
                title={result._highlight ? "Cliquer pour ajouter depuis le catalogue" : "Cliquer pour éditer"}
              >
                <span className="DropdownItemText">
                  <strong>{result.label}</strong> {result.unit && <span>({result.unit})</span>}
                </span>
              </button>
            ))}
            {filtered.length > 15 && (
              <div className="DropdownMore">
                <em style={{ fontSize: 12, color: "#999" }}>... et {filtered.length - 15} autres résultats (affinez votre recherche)</em>
              </div>
            )}
          </div>
        )}
      </div>

      {loading && <div className="Empty">Chargement…</div>}

      {!loading &&
        filtered.map((r) => {
          // Si on a une recherche active, afficher seulement les résultats locaux
          if (q && r._highlight) return null;

          const isEditing = editingRows[r.id];
          const canSave = isEditing && !r.duplicate && !r.inDb;

          return (
            <div className="Row" key={r.id} style={{ position: "relative" }}>
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <input
                    ref={(el) => {
                      if (el && activeEditingId === r.id && r.label === "" && isEditing) {
                        setTimeout(() => el.focus(), 10);
                      }
                    }}
                    className={`Input md ${r.duplicate || r.inDb ? "is-dup" : ""}`}
                    value={r.label}
                    placeholder="Paramètre (ex: glycémie)"
                    disabled={!isEditing}
                    onChange={(e) => handleLabelChange(r.id, e.target.value)}
                    style={{
                      paddingRight: r.inDb ? '90px' : '12px',
                      width: '250px'
                    }}
                  />
                  
                  {r.inDb && (
                    <span 
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#dc3545',
                        fontSize: '12px',
                        fontWeight: 'normal',
                        pointerEvents: 'none',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '2px 6px',
                        borderRadius: '3px'
                      }}
                    >
                      existe deja
                    </span>
                  )}
                </div>

                {r.duplicate && !r.inDb && (
                  <div className="DupBadge DupBadge--error">
                    Déjà dans la liste
                  </div>
                )}

                {activeEditingId === r.id && suggestions.length > 0 && (
                  <div className="SuggestionsDropdown">
                    {suggestions.map((s) => {
                      const label = s.label || s.parametre || s.nom || "";
                      return (
                        <div
                          key={s.id}
                          className="SuggestionItem"
                          onClick={() => selectSuggestion(s)}
                        >
                          <span className="SuggestionLabel">{label}</span>
                          {s.unite && (
                            <span className="SuggestionUnit">({s.unite})</span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              <input
                className="Input sm"
                value={r.unit}
                onChange={(e) => update(r.id, "unit", e.target.value)}
                placeholder="unité"
                disabled={!isEditing}
                style={{ width: '80px' }}
              />

              <input
                className="Input xxs"
                type="number"
                value={r.min}
                onChange={(e) => update(r.id, "min", e.target.value)}
                placeholder="min"
                disabled={!isEditing}
                style={{ marginLeft: "18px", width: '70px' }}
              />

              <input
                className="Input xxs"
                type="number"
                value={r.max}
                onChange={(e) => update(r.id, "max", e.target.value)}
                placeholder="max"
                disabled={!isEditing}
                style={{ marginLeft: "18px", width: '70px' }}
              />

              <button
                className="Btn small"
                onClick={() => saveRow(r)}
                disabled={!canSave || savingRows[r.id]}
              >
                {savingRows[r.id] ? "Enregistrement…" : "Enregistrer"}
              </button>

              <button className="Btn small" onClick={() => toggleEdit(r.id)}>
                {isEditing ? "Annuler" : "Edit"}
              </button>

              <button className="IconBtn danger" onClick={() => remove(r.id)}>
                <X size={16} />
              </button>
            </div>
          );
        })}

      <style>{`
        /* ===== DROPDOWN STYLES ===== */
        .SearchBar {
          position: relative;
          z-index: 1000;
        }
        .SearchDropdown {
          position: absolute;
          top: 55%;
          left: 0;
          right: 0;
          width: 50%;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-top: none;
          border-radius: 0 0 8px 8px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
          max-height: 500px;
          overflow-y: auto;
          z-index: 9999;
        }
        .DropdownHeader {
          padding: 10px 12px;
          border-bottom: 1px solid #f0f0f0;
          background: #fafafa;
          font-weight: 600;
          color: #333;
          position: sticky;
          top: 0;
          z-index: 10000;
        }
        .DropdownItem {
          display: flex;
          width: 55%;
          padding: 10px 12px;
          border: none;
          background: transparent;
          text-align: left;
          cursor: pointer;
          border-bottom: 1px solid #f5f5f5;
          transition: background 0.15s;
        }
        .DropdownItem:last-child {
          border-bottom: none;
        }
        .DropdownItem:hover {
          background: #f9f9f9;
        }
        .DropdownItemText {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          font-size: 13px;
        }
        .DropdownItemBadge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 999px;
          background: #dbeafe;
          color: #0369a1;
          font-size: 11px;
          white-space: nowrap;
          margin-left: auto;
          flex-shrink: 0;
        }
        .DropdownMore {
          padding: 10px 12px;
          text-align: center;
          background: #fafafa;
          border-top: 1px solid #f0f0f0;
          color: #999;
        }
      `}</style>
    </div>
  );
}


/* ---------- Onglet 4 : Étapes Timeline + Templates ---------- */

const hexToRgba = (hex, a = 0.08) => {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "#A0AEC0");
  if (!m) return `rgba(160,174,192,${a})`;
  return `rgba(${parseInt(m[1],16)},${parseInt(m[2],16)},${parseInt(m[3],16)},${a})`;
};
async function ensureCardsForSteps(doctorId, cleaned = []) {
  let existing = [];
  try {
    const fetched = await fetchTimelineCards(doctorId);
    existing = Array.isArray(fetched) ? fetched : [];
  } catch (e) {
    console.warn("ensureCardsForSteps: fetchTimelineCards failed, continuing with empty list", e);
    existing = [];
  }

  const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

  const index = new Map();
  for (const c of existing) {
    const key = `${norm(c.label)}|${String(c.color || "").toUpperCase()}`;
    if (!index.has(key)) index.set(key, c);
  }

  const result = [];
  for (const item of cleaned) {
    const label = (item.label || "").trim();
    const color = String(item.color || "#A0AEC0").toUpperCase();
    const key = `${norm(label)}|${color}`;

    if (index.has(key)) {
      result.push(index.get(key));
      continue;
    }

    try {
      const created = await createTimelineCard(doctorId, { label, color });
      const createdKey = `${norm(created.label)}|${String(created.color || "").toUpperCase()}`;
      index.set(createdKey, created);
      result.push(created);
    } catch (e) {
      console.error("ensureCardsForSteps: createTimelineCard failed for", item, e?.response?.data || e);
      throw new Error(`Impossible de créer la card "${label}" (${color}). Voir console pour détail.`);
    }
  }

  return result;
}
// Helpers d’IDs temporaires (une seule fois, hors composant)
const tmpId = () => `tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`;
const isTempId = (id) => typeof id === "string" && id.startsWith("tmp_");

function TimelineEtapes() {
  const palette = ["#3f6dcc","#d0701f","#f0c34a","#10b981","#06b6d4","#818cf8","#ef4444","#8b5cf6"];
  const doctorId = useMemo(getDoctorIdFromLoginInfo, []);
  const [busy, setBusy] = useState(false);
  const [toast, setToast] = useState(null);
  const [notification, setNotification] = useState({ show: false, message: "", type: "" });

  const showNotification = (message, type = "info") => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: "", type: "" });
    }, 3000);
  };

  /* ============================================
   * A. ÉTAPES — créer (nom+couleur) puis enregistrer
   * ============================================ */
  // step: {id, label, color, _isNew?, _draftLabel?, _draftColor?}
  const [steps, setSteps] = useState([]);

  const addStep = () => {
    const color = palette[steps.length % palette.length];
    const newStep = { 
      id: tmpId(), 
      label: "", 
      color, 
      _isNew: true, 
      _draftLabel: "", 
      _draftColor: color 
    };
    // Ajouter EN HAUT
    setSteps((s) => [newStep, ...s]);
  };

  const changeNewStep = (id, key, val) => {
    setSteps((s) => s.map((x) => (
      x.id === id ? { ...x, [key === "label" ? "_draftLabel" : "_draftColor"]: val } : x
    )));
  };

  const cancelNewStep = (id) => {
    setSteps((s) => s.filter((x) => x.id !== id));
  };

  const saveNewStep = async (id) => {
    const row = steps.find((x) => x.id === id);
    if (!row) return;
    const label = String(row._draftLabel || "").trim();
    const color = String(row._draftColor || row.color || "#A0AEC0").toUpperCase();
    if (!label) return setToast("Nom de l'étape requis.");

    // Vérifier si une étape avec le même nom existe déjà
    if (steps.some(s => 
      !isTempId(s.id) && 
      s.id !== id && 
      s.label.trim().toLowerCase() === label.toLowerCase()
    )) {
      return showNotification(`Une étape avec le nom "${label}" existe déjà !`, "warning");
    }

    setBusy(true);
    try {
      const created = await createTimelineEtape(doctorId, { label, color });
      
      // Remplacer la nouvelle étape par celle créée (elle reste en haut)
      setSteps((s) =>
        s.map((x) => (x.id === id ? { 
          id: created.id, 
          label: created.label, 
          color: created.color 
        } : x))
      );
      
      // Recharger les cartes pour ne pas afficher la carte auto-créée avec l'étape
      // Si le backend crée une carte automatiquement avec l'étape, il faut la supprimer
      const cards = await fetchTimelineCards(doctorId);
      // Garder seulement les cartes qui n'ont pas le même ID que l'étape créée
      const filteredCards = cards.filter(c => c.id !== created.id);
      setCardConfigs(filteredCards.map((c) => ({ id: c.id, title: c.label, color: c.color })));
    } catch (e) {
      console.error("save step:", e?.response?.data || e);
      setToast("Erreur: enregistrement étape");
    } finally {
      setBusy(false);
    }
  };

  const removeStep = async (id) => {
    if (isTempId(id)) {
      setSteps((s) => s.filter((x) => x.id !== id));
      return;
    }
    setBusy(true);
    try {
      await deleteTimelineEtape(doctorId, Number(id));
      setSteps((s) => s.filter((x) => x.id !== id));
    } catch (e) {
      console.error("delete step:", e?.response?.data || e);
      setToast("Erreur: suppression étape");
    } finally {
      setBusy(false);
    }
  };

  /* ============================================
   * B. TEMPLATES (utilisent des étapes existantes)
   * ============================================ */
  const [templates, setTemplates] = useState([]);
  const [showBuilder, setShowBuilder] = useState(false);
  const [builder, setBuilder] = useState({
    name: "",
    steps: [{ id: tmpId(), etape_id: null, duree: 0 }],
  });

  const openBuilder = () => {
    const persistedSteps = steps.filter((s) => !isTempId(s.id));
    if (!persistedSteps.length) {
      setToast("Crée et enregistre au moins une étape avant de construire un template.");
      return;
    }
    setBuilder({
      name: "",
      steps: [{ id: tmpId(), etape_id: persistedSteps[0].id, duree: 0 }],
    });
    setShowBuilder(true);
  };

  const addBuilderStep = () =>
    setBuilder((b) => ({
      ...b,
      steps: [
        ...b.steps,
        { id: tmpId(), etape_id: (steps.find(s => !isTempId(s.id))?.id) ?? null, duree: 0 }, // Ajouter à la fin pour respecter l'ordre d'ajout
      ],
    }));

  const updateBuilderStep = (sid, key, val) =>
    setBuilder((b) => ({
      ...b,
      steps: b.steps.map((s) => (s.id === sid ? { ...s, [key]: val } : s)),
    }));

  const removeBuilderStep = (sid) =>
    setBuilder((b) => ({ ...b, steps: b.steps.filter((s) => s.id !== sid) }));

  const deleteTemplate = async (id) => {
    setBusy(true);
    try {
      await deleteTimelineTemplate(doctorId, id);
      setTemplates((t) => t.filter((tp) => tp.id !== id));
    } catch (e) {
      console.error("delete template:", e?.response?.data || e);
      setToast("Erreur: suppression template");
    } finally {
      setBusy(false);
    }
  };

  const saveTemplate = async () => {
    const name = builder.name.trim();
    if (!name) return showNotification("Nom du template requis.", "warning");
    if (!builder.steps.length) return showNotification("Ajoute au moins une étape.", "warning");
    if (builder.steps.some((s) => !s.etape_id)) return showNotification("Choisis une étape sur chaque ligne.", "warning");

    if (templates.some((t) => t.name.toLowerCase() === name.toLowerCase())) {
      return showNotification(`Un template avec le nom "${name}" existe déjà !`, "warning");
    }

    setBusy(true);
    try {
      const tpl = await createTimelineTemplate(doctorId, { name });
      const stepsForApi = builder.steps.map((s, i) => ({
        etape_id: Number(s.etape_id),
        ordre: i + 1,
        duree_jours: Number(s.duree ?? 0),
      }));
      await setTimelineTemplateSteps(doctorId, tpl.id, stepsForApi);
      await reloadTemplatesHydrated();
      setShowBuilder(false);
      showNotification(`Template "${name}" enregistré avec succès !`, "success");
    } catch (e) {
      console.error("save template:", e?.response?.data || e);
      const msg = e?.response?.data?.message || "Erreur: enregistrement template";
      if (msg.includes("Integrity") || msg.includes("Duplicate")) {
        showNotification(`Un template avec le nom "${name}" existe déjà !`, "warning");
      } else {
        showNotification("Erreur lors de l'enregistrement du template.", "error");
      }
    } finally {
      setBusy(false);
    }
  };

  const reloadTemplatesHydrated = async () => {
    try {
      const [etapesSrv, tpls] = await Promise.all([
        fetchTimelineEtapes(doctorId),
        fetchTimelineTemplates(doctorId),
      ]);
      const mapById = new Map(etapesSrv.map((c) => [c.id, c]));
      const full = [];
      for (const t of tpls) {
        const det = await fetchTimelineTemplate(doctorId, t.id);
        const stepsHydrated = Array.isArray(det?.steps)
            ? det.steps.map((s) => {
                const base = mapById.get(Number(s.etape_id));
                const color = s?.color_override ?? s?.couleur_override ?? base?.color ?? "#A0AEC0";
                const label = s?.titre_override ?? s?.nom_override ?? base?.label ?? "Étape";
                const duree = Number(s?.duree_jours ?? 0);
                return { label, color, duree };
              })
            : [];
        // Ajouter les nouveaux templates EN HAUT
        full.unshift({ id: t.id, name: t.name, steps: stepsHydrated });
      }
      setTemplates(full);
    } catch (e) {
      console.error("load templates:", e?.response?.data || e);
      setToast("Erreur: chargement templates");
    }
  };

  /* ============================================
   * C. CARTES — créer (titre+couleur) puis enregistrer
   * ============================================ */
  // card: {id, title, color, _isNew?, _draftTitle?, _draftColor?}
  const [cardConfigs, setCardConfigs] = useState([]);

  const addCard = () => {
    const color = palette[cardConfigs.length % palette.length];
    const newCard = { 
      id: tmpId(), 
      title: "", 
      color, 
      _isNew: true, 
      _draftTitle: "", 
      _draftColor: color 
    };
    // Ajouter EN HAUT
    setCardConfigs((cs) => [newCard, ...cs]);
  };

  const changeNewCard = (id, key, val) => {
    setCardConfigs((cs) => cs.map((c) => (
      c.id === id ? { ...c, [key === "title" ? "_draftTitle" : "_draftColor"]: val } : c
    )));
  };

  const cancelNewCard = (id) => {
    setCardConfigs((cs) => cs.filter((c) => c.id !== id));
  };

  const saveNewCard = async (id) => {
    const row = cardConfigs.find((c) => c.id === id);
    if (!row) return;
    const title = String(row._draftTitle || "").trim();
    const color = String(row._draftColor || row.color || "#A0AEC0").toUpperCase();
    if (!title) return setToast("Titre de la carte requis.");

    if (cardConfigs.some(c => 
      !isTempId(c.id) && 
      c.id !== id && 
      c.title.trim().toLowerCase() === title.toLowerCase()
    )) {
      return showNotification(`Une carte avec le titre "${title}" existe déjà !`, "warning");
    }

    setBusy(true);
    try {
      const created = await createTimelineCard(doctorId, { label: title, color });
      // Remplacer la nouvelle carte par celle créée (elle reste en haut)
      setCardConfigs((cs) =>
        cs.map((c) => (c.id === id ? { 
          id: created.id, 
          title: created.label, 
          color: created.color 
        } : c))
      );
    } catch (e) {
      console.error("save card:", e?.response?.data || e);
      setToast("Erreur: enregistrement carte");
    } finally {
      setBusy(false);
    }
  };

  const removeCard = async (id) => {
    if (isTempId(id)) {
      setCardConfigs((cs) => cs.filter((c) => c.id !== id));
      return;
    }
    setBusy(true);
    try {
      await deleteTimelineCard(doctorId, Number(id));
      setCardConfigs((cs) => cs.filter((c) => c.id !== id));
    } catch (e) {
      console.error("delete card:", e?.response?.data || e);
      setToast("Erreur: suppression carte");
    } finally {
      setBusy(false);
    }
  };

  /* ============================================
   * LOAD INIT - Charger avec les nouveaux éléments en haut
   * ============================================ */
  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const etapes = await fetchTimelineEtapes(doctorId);
        if (!on) return;
        // Inverser l'ordre pour mettre les derniers ajouts en haut
        setSteps(etapes.reverse());

        const cards = await fetchTimelineCards(doctorId);
        if (!on) return;
        // Inverser l'ordre pour mettre les derniers ajouts en haut
        setCardConfigs(cards.map((c) => ({ id: c.id, title: c.label, color: c.color })).reverse());

        await reloadTemplatesHydrated();
      } catch (e) {
        console.error("init:", e?.response?.data || e);
        setToast("Erreur: chargement");
      }
    })();
    return () => { on = false; };
  }, [doctorId]);

  /* ======================= UI ======================= */
  return (
    <div className="Grid2">
      {/* ---------- A. Étapes ---------- */}
      <div className="Card">
        <div className="CardHead">
          <span>Listes des étapes - timeline</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="Btn" onClick={addStep} disabled={busy}>
              <Plus size={16} /> Ajouter étape
            </button>
          </div>
        </div>

        {steps.length === 0 && (
          <div className="Empty">
            <h4>Aucune étape</h4>
            <p>Ajoute une étape pour démarrer.</p>
          </div>
        )}

        {steps.map((s) => {
          const isNew = !!s._isNew;
          const valLabel = isNew ? (s._draftLabel ?? "") : s.label;
          const valColor = isNew ? (s._draftColor ?? s.color) : s.color;

          const hasDuplicate = steps.some(other => 
            !isTempId(other.id) && 
            other.id !== s.id && 
            other.label.trim().toLowerCase() === valLabel.trim().toLowerCase()
          );

          return (
            <div className="Row" key={s.id}>
              <span
                style={{
                  width: 12, height: 12, borderRadius: 999, background: valColor,
                  display: "inline-block", marginRight: 8, flex: "0 0 12px",
                }}
                aria-hidden
              />

              <div style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  className={`Input md ${hasDuplicate && !isNew ? "is-dup" : ""}`}
                  value={valLabel}
                  onChange={(e) => isNew && changeNewStep(s.id, "label", e.target.value)}
                  placeholder="Nom de l'étape"
                  readOnly={!isNew}
                  style={{ 
                    border: `1px solid ${valColor}`,
                    paddingRight: hasDuplicate && !isNew ? '90px' : '12px',
                    width: '250px'
                  }}
                  autoFocus={isNew}
                />
                
                {hasDuplicate && !isNew && (
                  <span 
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#dc3545',
                      fontSize: '12px',
                      fontWeight: 'normal',
                      pointerEvents: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      padding: '2px 6px',
                      borderRadius: '3px'
                    }}
                  >
                    existe déjà
                  </span>
                )}
              </div>

              {isNew && (
                <div className="Palette" style={{ marginLeft: 8 }}>
                  {palette.map((c) => (
                    <button
                      key={c}
                      type="button"
                      className={`Swatch ${valColor === c ? "is-active" : ""}`}
                      style={{ background: c }}
                      onClick={() => changeNewStep(s.id, "color", c)}
                      aria-label={`Couleur ${c}`}
                      disabled={busy}
                    />
                  ))}
                  <input
                    className="Color"
                    type="color"
                    value={valColor}
                    onChange={(e) => changeNewStep(s.id, "color", e.target.value)}
                    title="Choisir une couleur"
                    disabled={busy}
                  />
                </div>
              )}

              {isNew ? (
                <>
                  <button 
                    className="IconBtn" 
                    onClick={() => saveNewStep(s.id)} 
                    title="Enregistrer" 
                    disabled={busy || !String(valLabel).trim()}
                  >
                    <Check size={16} />
                  </button>
                  <button className="IconBtn Btn--ghost" onClick={() => cancelNewStep(s.id)} title="Annuler" disabled={busy}>
                    <RotateCcw size={16} />
                  </button>
                  <button className="IconBtn danger" onClick={() => removeStep(s.id)} title="Supprimer" disabled={busy}>
                    <X size={16} />
                  </button>
                </>
              ) : (
                <button className="IconBtn danger" onClick={() => removeStep(s.id)} title="Supprimer" disabled={busy}>
                  <X size={16} />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* ---------- B. Templates ---------- */}
      <div className="Card">
        <div className="CardHead">
          <span>Timeline templates</span>
          <button className="Btn Btn--ghost" onClick={openBuilder} disabled={busy}>
            <Plus size={16} /> Créer un template
          </button>
        </div>

        <div className="Templates">
          {templates.length === 0 && (
            <div className="Empty">
              <h4>Aucun template</h4>
              <p>Clique sur "Créer un template" pour en ajouter.</p>
            </div>
          )}

          {templates.map((tp) => (
            <div className="TemplateCard" key={tp.id}>
              <div className="TemplateHeader">
                <strong>{tp.name}</strong>
                <button className="IconBtn danger" onClick={() => deleteTemplate(tp.id)} title="Supprimer" disabled={busy}>
                  <X size={16} />
                </button>
              </div>

              <div className="TemplateRow" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {tp.steps?.map((st, idx) => (
                  <div
                    key={idx}
                    className="ChipStep"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      padding: "6px 10px",
                      borderRadius: 14,
                      border: `1px solid ${st.color}`,
                      background: "#fff",
                    }}
                  >
                    <span
                      style={{
                        width: 8, height: 8, borderRadius: 999, background: st.color, display: "inline-block",
                      }}
                    />
                    <span style={{ fontSize: 13 }}>{idx + 1}. {st.label}</span>
                    {Number(st.duree || 0) > 0 && (
                      <span className="GapBadge" style={{ fontSize: 12, opacity: 0.75 }}>+{Number(st.duree)}j</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {showBuilder && (
          <div className="TBCard">
            <div className="TBHead">
              <strong>Nouveau template</strong>
              <button className="IconBtn" onClick={() => setShowBuilder(false)} title="Fermer">
                <X size={16} />
              </button>
            </div>

            <div className="Row">
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  className={`Input md ${templates.some(t => t.name.toLowerCase() === builder.name.trim().toLowerCase()) ? "is-dup" : ""}`}
                  placeholder="Nom du template (ex: Consultation 3 mois)"
                  value={builder.name}
                  onChange={(e) => setBuilder((b) => ({ ...b, name: e.target.value }))}
                  disabled={busy}
                  style={{
                    paddingRight: templates.some(t => t.name.toLowerCase() === builder.name.trim().toLowerCase()) ? '90px' : '12px',
                    width: '300px'
                  }}
                />
                
                {templates.some(t => t.name.toLowerCase() === builder.name.trim().toLowerCase()) && (
                  <span 
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#dc3545',
                      fontSize: '12px',
                      fontWeight: 'normal',
                      pointerEvents: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      padding: '2px 6px',
                      borderRadius: '3px'
                    }}
                  >
                    existe déjà
                  </span>
                )}
              </div>
            </div>

            {builder.steps.map((st, index) => {
              const persisted = steps.filter((e) => !isTempId(e.id));
              const prev = persisted.find((e) => Number(e.id) === Number(st.etape_id));

              return (
                <div className="TBRow" key={st.id} style={{ display: "grid", gridTemplateColumns: "1.5rem 1fr auto auto auto", gap: 8, alignItems: "center" }}>
                  <span className="OrderBadge">{index + 1}</span>

                  <select
                    className="Input md"
                    value={st.etape_id ?? ""}
                    onChange={(e) => updateBuilderStep(st.id, "etape_id", Number(e.target.value) || null)}
                    disabled={busy || !persisted.length}
                  >
                    <option value="" disabled>Choisir une étape…</option>
                    {persisted.map((et) => (
                      <option key={et.id} value={et.id}>{et.label}</option>
                    ))}
                  </select>

                  <span
                    title="Couleur de l'étape"
                    style={{
                      width: 18, height: 18, borderRadius: 999,
                      background: prev?.color || "#ddd", display: "inline-block",
                      border: `1px solid ${prev?.color || "#ddd"}`
                    }}
                  />

                  <div className="GapField" title="Durée jusqu'à l'étape suivante (jours)" style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span className="GapSep">⟶</span>
                    <input
                      className="Input xxs"
                      type="number"
                      min="0"
                      value={st.duree ?? 0}
                      onChange={(e) => updateBuilderStep(st.id, "duree", Math.max(0, Number(e.target.value || 0)))}
                      placeholder="jours"
                      aria-label="Durée (jours) vers la suivante"
                      disabled={busy}
                      style={{ width: 80 }}
                    />
                    <span className="GapUnit">jours</span>
                  </div>

                  <button className="IconBtn danger" onClick={() => removeBuilderStep(st.id)} title="Supprimer la ligne" disabled={busy}>
                    <X size={16} />
                  </button>
                </div>
              );
            })}

            <div className="TBFooter">
              <button className="Btn Btn--ghost" onClick={addBuilderStep} disabled={busy || !steps.filter(s=>!isTempId(s.id)).length}>
                <Plus size={16} /> Ajouter une étape
              </button>
              <div style={{ flex: 1 }} />
              <button className="Btn Btn--ghost" onClick={() => setShowBuilder(false)}>Annuler</button>
              <button 
                className="Btn" 
                onClick={saveTemplate} 
                disabled={busy || templates.some(t => t.name.toLowerCase() === builder.name.trim().toLowerCase())}
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ---------- C. Cartes ---------- */}
      <div className="Card">
        <div className="CardHead">
          <span>Configuration des cartes</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="Btn" onClick={addCard} disabled={busy}>
              <Plus size={16} /> Ajouter une carte
            </button>
          </div>
        </div>

        {cardConfigs.length === 0 && (
          <div className="Empty">
            <h4>Aucune carte</h4>
            <p>Ajoute une carte pour définir un titre.</p>
          </div>
        )}

        {cardConfigs.map((cfg) => {
          const isNew = !!cfg._isNew;
          const valTitle = isNew ? (cfg._draftTitle ?? "") : cfg.title;
          const valColor = isNew ? (cfg._draftColor ?? cfg.color) : cfg.color;

          const hasDuplicate = cardConfigs.some(other => 
            !isTempId(other.id) && 
            other.id !== cfg.id && 
            other.title.trim().toLowerCase() === valTitle.trim().toLowerCase()
          );

          return (
            <div className="Row" key={cfg.id}>
              <span
                style={{
                  width: 12, height: 12, borderRadius: 999, background: valColor,
                  display: "inline-block", marginRight: 8, flex: "0 0 12px",
                }}
                aria-hidden
              />

              <div style={{ position: 'relative', display: 'inline-block' }}>
                <input
                  className={`Input md ${hasDuplicate && !isNew ? "is-dup" : ""}`}
                  placeholder="Titre de la carte"
                  value={valTitle}
                  onChange={(e) => isNew && changeNewCard(cfg.id, "title", e.target.value)}
                  readOnly={!isNew}
                  style={{ 
                    border: `1px solid ${valColor}`,
                    paddingRight: hasDuplicate && !isNew ? '90px' : '12px',
                    width: '250px'
                  }}
                  autoFocus={isNew}
                />
                
                {hasDuplicate && !isNew && (
                  <span 
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#dc3545',
                      fontSize: '12px',
                      fontWeight: 'normal',
                      pointerEvents: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.9)',
                      padding: '2px 6px',
                      borderRadius: '3px'
                    }}
                  >
                    existe déjà
                  </span>
                )}
              </div>

              {isNew && (
                <div className="Palette" style={{ marginLeft: 8 }}>
                  {palette.map((c) => (
                    <button
                      key={c}
                      type="button"
                      className={`Swatch ${valColor === c ? "is-active" : ""}`}
                      style={{ background: c }}
                      onClick={() => changeNewCard(cfg.id, "color", c)}
                      aria-label={`Couleur ${c}`}
                      disabled={busy}
                    />
                  ))}
                  <input
                    className="Color"
                    type="color"
                    value={valColor}
                    onChange={(e) => changeNewCard(cfg.id, "color", e.target.value)}
                    title="Choisir une couleur personnalisée"
                    disabled={busy}
                  />
                </div>
              )}

              {isNew ? (
                <>
                  <button 
                    className="IconBtn" 
                    onClick={() => saveNewCard(cfg.id)} 
                    title="Enregistrer" 
                    disabled={busy || !String(valTitle).trim()}
                  >
                    <Check size={16} />
                  </button>
                  <button className="IconBtn Btn--ghost" onClick={() => cancelNewCard(cfg.id)} title="Annuler" disabled={busy}>
                    <RotateCcw size={16} />
                  </button>
                  <button className="IconBtn danger" onClick={() => removeCard(cfg.id)} title="Supprimer" disabled={busy}>
                    <X size={16} />
                  </button>
                </>
              ) : (
                <button className="IconBtn danger" onClick={() => removeCard(cfg.id)} title="Supprimer" disabled={busy}>
                  <X size={16} />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {toast && (
        <div className="Toast" role="status" onAnimationEnd={() => setToast(null)}>
          {toast}
        </div>
      )}
    </div>
  );
}

/* ---------- Onglets 5 & 6 : listes simples avec recherche ---------- */
function SimpleList({ title = "Antécédents (avec options)" }) {
  const cryptoRandom = React.useCallback(
    () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );
  const normalize = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const [q, setQ] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [allTitles, setAllTitles] = React.useState([]);
  const [openSugFor, setOpenSugFor] = React.useState(null);
  const [savingRow, setSavingRow] = React.useState({});
  const [focusId, setFocusId] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const newOptRefs = React.useRef({});
  const searchBarRef = React.useRef(null);

  const DOC_doctorId = React.useMemo(getDoctorIdFromLoginInfo, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
        setQ("");
      }
    };
    if (q) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [q]);

  const COMMON_OPTIONS = React.useMemo(
    () => [
      "Léger",
      "Modéré",
      "Sévère",
      "Chronique",
      "Aigu",
      "Instable",
      "Stable",
      "Persistant",
      "Transitoire",
      "Exacerbation",
      "Progressif",
      "Récidivant",
      "Non compliqué",
      "Compliqué",
      "Aggravation",
      "Terminale",
      "Réversible",
      "Irréversible",
      "Avancé",
    ],
    []
  );

  const markRow = (id, patch) =>
    setRows((r) => r.map((x) => (x.id === id ? { ...x, ...patch } : x)));

  const alreadyInList = React.useCallback(
    (label, excludeId = null) =>
      rows.some((r) => r.id !== excludeId && normalize(r.titre) === normalize(label)),
    [rows]
  );
  const inLibrary = React.useCallback(
    (label) => allTitles.some((t) => normalize(t) === normalize(label)),
    [allTitles]
  );

  // ➜ AJOUTE EN HAUT + FOCUS AUTO
  const addRow = () => {
    const id = cryptoRandom();
    const newRow = {
      id,
      titre: "",
      options: [],
      exists: false,
      isEditing: true,
      duplicate: false,
      inDb: false,
      lockedBySug: false,
      _pickerOpen: false,
    };
    setRows((r) => [newRow, ...r]); // prepend
    setFocusId(id);                 // focus sur la nouvelle ligne
    // setOpenSugFor(id);            // (optionnel) ouvrir les suggestions
    // window.scrollTo({ top: 0, behavior: "smooth" }); // (optionnel) remonter la page
  };

  const removeRow = async (id) => {
    if (!Number.isNaN(Number(id)) && Number(id) > 0 && DOC_doctorId) {
      try {
        await deleteAntecedentConfigApi(DOC_doctorId, Number(id));
      } catch {}
    }
    setRows((r) => r.filter((x) => x.id !== id));
  };

  const toggleEdit = (id, on) => {
    markRow(id, { isEditing: on });
    if (on) setFocusId(id);
  };

  const updateTitle = (id, v) =>
    setRows((r) =>
      r.map((x) => {
        if (x.id !== id) return x;
        const isNew = !x.exists || Number.isNaN(Number(x.id)) || Number(x.id) <= 0;
        if (!x.isEditing && !isNew) return x;
        const dup = alreadyInList(v, id);
        return {
          ...x,
          titre: v,
          duplicate: dup,
          inDb: inLibrary(v),
          lockedBySug: false,
        };
      })
    );

  const addOption = (id, opt) => {
    const v = (opt || "").trim();
    if (!v) return;
    setRows((r) =>
      r.map((x) =>
        x.id === id
          ? {
              ...x,
              options:
                x.options.length >= 16
                  ? x.options
                  : x.options.includes(v)
                  ? x.options
                  : [...x.options, v],
            }
          : x
      )
    );
  };

  const removeOption = (id, idx) =>
    setRows((r) =>
      r.map((x) =>
        x.id === id ? { ...x, options: x.options.filter((_, i) => i !== idx) } : x
      )
    );

  const togglePicker = (id, open) =>
    setRows((r) =>
      r.map((x) => (x.id === id ? { ...x, _pickerOpen: open ?? !x._pickerOpen } : x))
    );

  const chooseFromSug = (id, value) => {
    const dup = alreadyInList(value, id);
    markRow(id, {
      titre: value,
      duplicate: dup,
      inDb: inLibrary(value),
      isEditing: true,
      lockedBySug: true,
    });
    setOpenSugFor(null);
    setFocusId(id);
  };

  const filtered = React.useMemo(() => {
    const needle = normalize(q);
    if (!needle) return rows; // si pas de recherche, affiche tous les rows
    
    // Cherche dans rows (données locales)
    const inRows = rows.filter(
      (x) =>
        normalize(x.titre).includes(needle) ||
        (x.options || []).some((o) => normalize(o).includes(needle))
    );
    
    // Cherche dans le catalogue (allTitles)
    const inCatalog = allTitles
      .filter((t) => normalize(t).includes(needle))
      .map((title) => ({
        id: `cat_${title}`,
        titre: title,
        options: [],
        exists: false,
        isEditing: false,
        duplicate: false,
        inDb: true,
        _highlight: true, // marquer comme du catalogue
      }))
      .filter((item) => !rows.some((r) => normalize(r.titre) === normalize(item.titre)));
    
    return [...inRows, ...inCatalog];
  }, [rows, q, allTitles]);

  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const titles = await fetchAntecedentTitles();
        setAllTitles(titles);

        if (DOC_doctorId) {
          const resp = await listAntecedentConfigsApi(DOC_doctorId);
          const list = Array.isArray(resp?.data?.data) ? resp.data.data : [];
          const mapRow = (d) => {
            const opts = [];
            for (let i = 1; i <= 16; i++) {
              const key = `option${i}`;
              if (d?.[key]) opts.push(String(d[key]));
            }
            return {
              id: d.id,
              titre: d.item || "",
              options: opts,
              exists: true,
              isEditing: false,
              duplicate: false,
              inDb: inLibrary(d.item || ""),
              lockedBySug: false,
              _pickerOpen: false,
            };
          };
          setRows((prev) => (prev.length ? prev : (list || []).map(mapRow)));
        }
      } catch (e) {
        console.error("[antecedents] init failed:", e);
        setAllTitles([]);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [DOC_doctorId]);

  const saveRowById = async (rowId) => {
    if (!DOC_doctorId) return;
    const row = rows.find((x) => x.id === rowId);
    if (!row) return;

    const item = String(row.titre || "").trim();
    if (!item) return;

    const payload = { item };
    (row.options || []).slice(0, 16).forEach((v, i) => {
      payload[`option${i + 1}`] = String(v);
    });
    if (!Number.isNaN(Number(rowId)) && Number(rowId) > 0) payload.id = Number(rowId);

    try {
      setSavingRow((m) => ({ ...m, [rowId]: true }));
      const { data } = await saveAntecedentConfigApi(DOC_doctorId, payload);
      const saved = data?.data || data || {};

      const savedOpts = [];
      for (let i = 1; i <= 16; i++) {
        const key = `option${i}`;
        if (saved?.[key]) savedOpts.push(String(saved[key]));
      }

      markRow(rowId, {
        id: saved?.id ?? rowId,
        titre: saved?.item ?? item,
        options: savedOpts.length ? savedOpts : row.options,
        exists: true,
        isEditing: false,
        duplicate: false,
        inDb: inLibrary(saved?.item ?? item),
        lockedBySug: false,
        _pickerOpen: false,
      });

      const finalItem = saved?.item ?? item;
      if (finalItem && !allTitles.some((t) => normalize(t) === normalize(finalItem))) {
        setAllTitles((old) => old.concat([finalItem]));
      }
    } catch (e) {
      console.error("saveAntecedentConfigApi failed:", e?.response?.data || e);
    } finally {
      setSavingRow((m) => ({ ...m, [rowId]: false }));
    }
  };

  const onKeyDown = (e, r) => {
    if (e.key === "Enter") {
      const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
      if ((r.isEditing || isNew) && !r.lockedBySug) {
        e.preventDefault();
        const item = String(r.titre || "").trim();
        if (item) saveRowById(r.id);
      }
    }
  };

  return (
    <div className="Card">
      <div className="CardHead">
        <span>{title}</span>
        <button className="Btn" onClick={addRow}>
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="SearchBar" ref={searchBarRef}>
        <Search size={16} />
        <input
          className="Input md"
          placeholder="Rechercher par nom ou option…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />

        {/* Dropdown des résultats de recherche */}
        {q && filtered.length > 0 && (
          <div className="SearchDropdown">
            <div className="DropdownHeader">
              <strong style={{ fontSize: 12, color: "#666" }}>Résultats ({Math.min(filtered.length, 15)} / {filtered.length})</strong>
            </div>
            {filtered.slice(0, 15).map((result) => (
              <button
                key={result.id}
                type="button"
                className="DropdownItem"
                onClick={() => {
                  if (!result._highlight) {
                    toggleEdit(result.id, true);
                    setFocusId(result.id);
                  } else {
                    // Ajouter depuis le catalogue
                    const id = cryptoRandom();
                    const newRow = {
                      id,
                      titre: result.titre,
                      options: [],
                      exists: false,
                      isEditing: true,
                      duplicate: false,
                      inDb: true,
                      lockedBySug: false,
                      _pickerOpen: false,
                    };
                    setRows((r) => [newRow, ...r]);
                    setFocusId(id);
                    setQ(""); // fermer dropdown
                  }
                }}
                title={result._highlight ? "Cliquer pour ajouter depuis le catalogue" : "Cliquer pour éditer"}
              >
                <span className="DropdownItemText">
                  {result.titre}
                  {result.duplicate && !result._highlight && <span className="DropdownItemBadge error">Doublon</span>}
                </span>
              </button>
            ))}
            {filtered.length > 15 && (
              <div className="DropdownMore">
                <em style={{ fontSize: 12, color: "#999" }}>... et {filtered.length - 15} autres résultats (affinez votre recherche)</em>
              </div>
            )}
          </div>
        )}
      </div>

      {filtered.map((r) => {
        // Si on a une recherche active, afficher seulement les résultats locaux (pas les du catalogue)
        if (q && r._highlight) return null;

        const n = normalize(r.titre);
        const sugs =
          r.isEditing && n.length
            ? allTitles.filter((t) => normalize(t).includes(n)).slice(0, 8)
            : [];

        const isSaving = !!savingRow[r.id];
        const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
        const canSave =
          (r.titre || "").trim().length > 0 && (r.isEditing || isNew);
        const readOnly = !r.isEditing && !isNew;
        const atLimit = (r.options || []).length >= 16;

        return (
          <div className="Row" key={r.id} style={{ position: "relative" }}>
            <div className="RelBox" style={{ position: "relative" }}>
              <input
                className={`Input lg ${r.duplicate ? "is-dup" : ""} ${
                  readOnly ? "is-readonly" : ""
                }`}
                style={{ width: '200px' }}
                placeholder="Nom de l’antécédent"
                value={r.titre}
                readOnly={readOnly}
                ref={(el) => {
                  if (el && focusId === r.id) {
                    try {
                      el.focus();
                      const L = el.value.length;
                      el.setSelectionRange(L, L);
                    } catch {}
                    setFocusId(null);
                  }
                }}
                onFocus={() => {
                  if (!readOnly) setOpenSugFor(r.id);
                }}
                onChange={(e) => {
                  updateTitle(r.id, e.target.value);
                  if (!readOnly) setOpenSugFor(r.id);
                }}
                onKeyDown={(e) => onKeyDown(e, r)}
                onBlur={() =>
                  setTimeout(
                    () => setOpenSugFor((p) => (p === r.id ? null : p)),
                    120
                  )
                }
              />
              {r._highlight && (
                <div className="CatalogBadge">📚 Catalogue</div>
              )}
              {r.duplicate && !r._highlight && (
                <div className="DupBadge DupBadge--error">déjà dans la liste</div>
              )}
              {!r.duplicate && r.inDb && r.isEditing && !r._highlight && (
                <div
                  className="DupBadge DupBadge--info"
                  title="Existe dans le catalogue"
                >
                  existe déjà
                </div>
              )}

              {openSugFor === r.id && (loading || sugs.length > 0) && (
                <div className="SuggestPanel">
                  {loading && (
                    <div className="SuggestItem muted">Chargement…</div>
                  )}
                  {!loading &&
                    sugs.map((t, i) => (
                      <button
                        key={t + i}
                        type="button"
                        className="SuggestItem"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => chooseFromSug(r.id, t)}
                        title="Choisir ce titre"
                      >
                        {t}
                      </button>
                    ))}
                </div>
              )}
            </div>

            <div className="ChipsWrap">
              {(r.options || []).map((opt, i) => (
                <span className="Chip Chip--option" key={opt + i}>
                  {opt}
                  {!readOnly && (
                    <button
                      type="button"
                      className="ChipX"
                      title="Retirer"
                      onClick={() => removeOption(r.id, i)}
                    >
                      ×
                    </button>
                  )}
                </span>
              ))}
            </div>

            <div className="FField" style={{ position: "relative" }}>
              {!readOnly && (
                <button
                  className="RoundBtn"
                  type="button"
                  title="Ajouter des options"
                  onClick={() => togglePicker(r.id, true)}
                >
                  +
                </button>
              )}

              {r._pickerOpen && (
                <div className="PickerCard" role="dialog" aria-modal="false">
                  <div className="PickerHead">
                    <strong>Ajouter des options</strong>
                    <button
                      className="IconBtn"
                      onClick={() => togglePicker(r.id, false)}
                      title="Fermer"
                    >
                      <X size={16} />
                    </button>
                  </div>

                  <div className="PickerBody">
                    <div className="PickerGrid">
                      {COMMON_OPTIONS.map((o) => (
                        <button
                          key={o}
                          type="button"
                          className="Chip Chip--ghost"
                          onClick={() => addOption(r.id, o)}
                          title={`Ajouter "${o}"`}
                          disabled={atLimit}
                        >
                          {o}
                        </button>
                      ))}
                    </div>

                    <div className="Inline" style={{ gap: 8 }}>
                      <input
                        className="Input md"
                        placeholder={
                          atLimit
                            ? "Limite 16 atteinte"
                            : "Nouvelle option… (Entrée pour ajouter)"
                        }
                        disabled={atLimit}
                        ref={(el) => {
                          newOptRefs.current[r.id] = el;
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            addOption(r.id, e.currentTarget.value);
                            e.currentTarget.value = "";
                          }
                        }}
                      />
                      <button
                        className="Btn Btn--ghost"
                        type="button"
                        onClick={() => {
                          const el = newOptRefs.current[r.id];
                          const val = el?.value?.trim();
                          if (val) {
                            addOption(r.id, val);
                            if (el) el.value = "";
                          }
                          togglePicker(r.id, false);
                        }}
                      >
                        Terminé
                      </button>
                      <span className="muted" style={{ fontSize: 12 }}>
                        {(r.options || []).length}/16
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="Inline" style={{ gap: 8 }}>
              {(r.isEditing || isNew) && (
                <button
                  className="IconBtn primary"
                  title={
                    r.lockedBySug
                      ? "Titre choisi dans le catalogue — modifiez-le pour activer ✓"
                      : "Enregistrer"
                  }
                  onClick={() => saveRowById(r.id)}
                  disabled={!canSave || isSaving || r.lockedBySug}
                >
                  {isSaving ? "…" : "✓"}
                </button>
              )}

              {!isNew && !r.isEditing && (
                <button
                  className="IconBtn"
                  title="Éditer"
                  onClick={() => toggleEdit(r.id, true)}
                >
                  ✎
                </button>
              )}

              {!isNew && (
                <button
                  className="IconBtn danger"
                  title="Supprimer"
                  onClick={() => removeRow(r.id)}
                >
                  <X size={16} />
                </button>
              )}
            </div>
          </div>
        );
      })}

      <style>{`
        /* ===== DROPDOWN STYLES ===== */
        .SearchBar {
          position: relative;
          z-index: 1000;
        }
        .SearchDropdown {
          position: absolute;
          top: 55%;
          left: 0;
          right: 0;
          width: 50%;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-top: none;
          border-radius: 0 0 8px 8px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
          max-height: 500px;
          overflow-y: auto;
          z-index: 9999;
        }
        .DropdownHeader {
          padding: 10px 12px;
          border-bottom: 1px solid #f0f0f0;
          background: #fafafa;
          font-weight: 600;
          color: #333;
          position: sticky;
          top: 0;
          z-index: 10000;
        }
        .DropdownItem {
          display: flex;
          width: 55%;
          padding: 10px 12px;
          border: none;
          background: transparent;
          text-align: left;
          cursor: pointer;
          border-bottom: 1px solid #f5f5f5;
          transition: background 0.15s;
        }
        .DropdownItem:last-child {
          border-bottom: none;
        }
        .DropdownItem:hover {
          background: #f9f9f9;
        }
        .DropdownItem.is-catalog {
          background: #f0f7ff;
        }
        .DropdownItem.is-catalog:hover {
          background: #e0f2ff;
        }
        .DropdownItemText {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          font-size: 13px;
        }
        .DropdownItemBadge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 999px;
          background: #dbeafe;
          color: #0369a1;
          font-size: 11px;
          white-space: nowrap;
          margin-left: auto;
          flex-shrink: 0;
        }
        .DropdownItemBadge.error {
          background: #fee2e2;
          color: #b91c1c;
        }
        .DropdownMore {
          padding: 10px 12px;
          text-align: center;
          background: #fafafa;
          border-top: 1px solid #f0f0f0;
          color: #999;
        }
      `}</style>
    </div>
  );
}

// ---- Component ----
function SimpleListt({ title = "Allergies (catégorie + item)" }) {
  // utils
  const cryptoRandom = React.useCallback(
    () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );
  const normalize = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  // state
  const [q, setQ] = React.useState("");
  const [rows, setRows] = React.useState([]);
  const [allAllergens, setAllAllergens] = React.useState([]); // [{categorie, allergene}]
  const [allCategories, setAllCategories] = React.useState([]);
  const [openSugFor, setOpenSugFor] = React.useState(null); // "cat:{id}" | "item:{id}"
  const [savingRow, setSavingRow] = React.useState({});
  const [focusId, setFocusId] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const searchBarRef = React.useRef(null);

  const DOC_doctorId = React.useMemo(getDoctorIdFromLoginInfo, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
        setQ("");
      }
    };
    if (q) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [q]);

  // helpers
  const markRow = (id, patch) =>
    setRows((r) => r.map((x) => (x.id === id ? { ...x, ...patch } : x)));

  const alreadyInList = React.useCallback(
    (cat, item, excludeId = null) =>
      rows.some(
        (r) =>
          r.id !== excludeId &&
          normalize(r.categorie) === normalize(cat) &&
          normalize(r.item) === normalize(item)
      ),
    [rows]
  );

  const inCatalog = React.useCallback(
    (cat, item) =>
      (allAllergens || []).some(
        (x) =>
          normalize(x.categorie) === normalize(cat) &&
          normalize(x.allergene) === normalize(item)
      ),
    [allAllergens]
  );

  const getCatSuggestions = (val) => {
    const n = normalize(val);
    if (!n) return allCategories.slice(0, 8);
    return allCategories.filter((c) => normalize(c).includes(n)).slice(0, 8);
  };

  const getItemSuggestions = (cat, typed) => {
    const catN = normalize(cat);
    if (!catN) return [];
    const options = (allAllergens || [])
      .filter((x) => normalize(x.categorie) === catN)
      .map((x) => String(x.allergene || "").trim())
      .filter(Boolean);
    const unique = Array.from(new Set(options));
    const needle = normalize(typed);
    return needle ? unique.filter((o) => normalize(o).includes(needle)) : unique;
  };

  // add / remove
  const add = () => {
    const id = cryptoRandom();
    const newRow = {
      id,
      categorie: "",
      item: "",
      exists: false,
      isEditing: true,
      duplicate: false,
      inDb: false,
      lockedBySug: false,
    };
    // ⬇️ insérer EN HAUT + focus auto
    setRows((r) => [newRow, ...r]);
    setFocusId(id);
    // (optionnel) ouvrir directement les suggestions de catégorie :
    // setOpenSugFor(`cat:${id}`);
    // (optionnel) remonter la page :
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const remove = async (id) => {
    if (!Number.isNaN(Number(id)) && Number(id) > 0 && DOC_doctorId) {
      try {
        await deleteAllergieConfigApi(DOC_doctorId, Number(id));
      } catch {}
    }
    setRows((r) => r.filter((x) => x.id !== id));
  };

  // edit
  const toggleEdit = (id, on) => {
    markRow(id, { isEditing: on });
    if (on) setFocusId(id);
  };

  const onChangeCategorie = (id, v) => {
    setRows((r) =>
      r.map((x) =>
        x.id !== id
          ? x
          : {
              ...x,
              categorie: v,
              duplicate: alreadyInList(v, x.item, id),
              inDb: inCatalog(v, x.item),
              lockedBySug: false,
            }
      )
    );
    setOpenSugFor(`cat:${id}`);
  };
  const chooseCategorie = (id, cat) => {
    setRows((r) =>
      r.map((x) =>
        x.id !== id
          ? x
          : {
              ...x,
              categorie: cat,
              duplicate: alreadyInList(cat, x.item, id),
              inDb: inCatalog(cat, x.item),
              lockedBySug: true,
            }
      )
    );
    setOpenSugFor(null);
    setFocusId(id);
  };

  const onChangeItem = (id, v) => {
    setRows((r) =>
      r.map((x) =>
        x.id !== id
          ? x
          : {
              ...x,
              item: v,
              duplicate: alreadyInList(x.categorie, v, id),
              inDb: inCatalog(x.categorie, v),
              lockedBySug: false,
            }
      )
    );
    setOpenSugFor(`item:${id}`);
  };
  const chooseItem = (id, it) => {
    setRows((r) =>
      r.map((x) =>
        x.id !== id
          ? x
          : {
              ...x,
              item: it,
              duplicate: alreadyInList(x.categorie, it, id),
              inDb: inCatalog(x.categorie, it),
              lockedBySug: true,
            }
      )
    );
    setOpenSugFor(null);
    setFocusId(id);
  };

  // init
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);

        const raw = await fetchAllAllergens();
        const mapped = (Array.isArray(raw) ? raw : [])
          .map((row) => ({
            categorie: String(row?.categorie ?? row?.groupe ?? "").trim(),
            allergene: String(row?.allergene ?? row?.element ?? "").trim(),
          }))
          .filter((x) => x.categorie && x.allergene);

        setAllAllergens(mapped);
        setAllCategories(
          Array.from(new Set(mapped.map((x) => x.categorie))).sort((a, b) =>
            a.localeCompare(b, "fr", { sensitivity: "base" })
          )
        );

        if (DOC_doctorId) {
          const resp = await listAllergieConfigsApi(DOC_doctorId);
          const list = Array.isArray(resp?.data?.data)
            ? resp.data.data
            : Array.isArray(resp?.data)
            ? resp.data
            : [];
          const initial = (list || []).map((d) => ({
            id: d.id,
            categorie: d.categorie || "",
            item: d.item || "",
            exists: true,
            isEditing: false,
            duplicate: false,
            lockedBySug: false,
            inDb: mapped.some(
              (x) =>
                normalize(x.categorie) === normalize(d.categorie || "") &&
                normalize(x.allergene) === normalize(d.item || "")
            ),
          }));
          setRows((prev) => (prev.length ? prev : initial));
        }
      } catch (e) {
        console.error("[allergies] init failed:", e?.response?.data || e);
        setAllAllergens([]);
        setAllCategories([]);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [DOC_doctorId]);

  // recalcule inDb si le catalogue change
  React.useEffect(() => {
    if (!allAllergens.length) return;
    setRows((r) => r.map((x) => ({ ...x, inDb: inCatalog(x.categorie, x.item) })));
  }, [allAllergens, inCatalog]);

  // save
  const saveRowById = async (rowId) => {
    if (!DOC_doctorId) return;
    const row = rows.find((x) => x.id === rowId);
    if (!row) return;

    const categorie = String(row.categorie || "").trim();
    const item = String(row.item || "").trim();
    if (!categorie || !item) return;
    if (row.duplicate || row.lockedBySug) return;

    const payload = { categorie, item };
    if (!Number.isNaN(Number(rowId)) && Number(rowId) > 0) payload.id = Number(rowId);

    try {
      setSavingRow((m) => ({ ...m, [rowId]: true }));
      const { data } = await saveAllergieConfigApi(DOC_doctorId, payload);
      const saved = data?.data || data || {};

      markRow(rowId, {
        id: saved?.id ?? rowId,
        categorie: saved?.categorie ?? categorie,
        item: saved?.item ?? item,
        exists: true,
        isEditing: false,
        duplicate: false,
        lockedBySug: false,
        inDb: inCatalog(saved?.categorie ?? categorie, saved?.item ?? item),
      });
    } catch (e) {
      console.error("saveAllergieConfigApi failed:", e?.response?.data || e);
    } finally {
      setSavingRow((m) => ({ ...m, [rowId]: false }));
    }
  };

  const onKeyDown = (e, r) => {
    if (e.key === "Enter") {
      const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
      if ((r.isEditing || isNew) && !r.lockedBySug) {
        e.preventDefault();
        const cat = String(r.categorie || "").trim();
        const it = String(r.item || "").trim();
        if (cat && it && !r.duplicate) saveRowById(r.id);
      }
    }
  };

  // filtre global
  const filtered = React.useMemo(() => {
    const needle = normalize(q);
    if (!needle) return rows;
    
    // Cherche dans rows (données locales)
    const inRows = rows.filter(
      (x) => normalize(x.categorie).includes(needle) || normalize(x.item).includes(needle)
    );
    
    // Cherche dans le catalogue (allAllergens)
    const inCatalog = (allAllergens || [])
      .filter(
        (allergen) =>
          normalize(allergen.categorie).includes(needle) ||
          normalize(allergen.allergene).includes(needle)
      )
      .map((allergen) => ({
        id: `cat_${allergen.categorie}_${allergen.allergene}`,
        categorie: allergen.categorie,
        item: allergen.allergene,
        exists: false,
        isEditing: false,
        duplicate: false,
        inDb: true,
        lockedBySug: false,
        _highlight: true, // marquer comme du catalogue
      }))
      .filter(
        (item) =>
          !rows.some(
            (r) =>
              normalize(r.categorie) === normalize(item.categorie) &&
              normalize(r.item) === normalize(item.item)
          )
      );
    
    return [...inRows, ...inCatalog];
  }, [rows, q, allAllergens]);

  return (
    <div className="Card">
      <div className="CardHead">
        <span>{title}</span>
        <button className="Btn" onClick={add}>
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="SearchBar search-black narrow" ref={searchBarRef}>
        <Search size={16} />
        <input
          className="Input md"
          placeholder="Rechercher par catégorie ou item…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />

        {/* Dropdown des résultats de recherche */}
        {q && filtered.length > 0 && (
          <div className="SearchDropdown">
            <div className="DropdownHeader">
              <strong style={{ fontSize: 12, color: "#666" }}>Résultats ({Math.min(filtered.length, 15)} / {filtered.length})</strong>
            </div>
            {filtered.slice(0, 15).map((result) => (
              <button
                key={result.id}
                type="button"
                className="DropdownItem"
                onClick={() => {
                  if (!result._highlight) {
                    toggleEdit(result.id, true);
                    setFocusId(result.id);
                  } else {
                    // Ajouter depuis le catalogue
                    const id = cryptoRandom();
                    const newRow = {
                      id,
                      categorie: result.categorie,
                      item: result.item,
                      exists: false,
                      isEditing: true,
                      duplicate: false,
                      inDb: true,
                      lockedBySug: false,
                    };
                    setRows((r) => [newRow, ...r]);
                    setFocusId(id);
                    setQ(""); // fermer dropdown
                  }
                }}
                title={result._highlight ? "Cliquer pour ajouter depuis le catalogue" : "Cliquer pour éditer"}
              >
                <span className="DropdownItemText">
                  <strong>{result.categorie}</strong> → {result.item}
                </span>
              </button>
            ))}
            {filtered.length > 15 && (
              <div className="DropdownMore">
                <em style={{ fontSize: 12, color: "#999" }}>... et {filtered.length - 15} autres résultats (affinez votre recherche)</em>
              </div>
            )}
          </div>
        )}
      </div>

      {filtered.map((r) => {
        // Si on a une recherche active, afficher seulement les résultats locaux
        if (q && r._highlight) return null;

        const isSaving = !!savingRow[r.id];
        const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
        const canSave =
          String(r.categorie || "").trim().length > 0 &&
          String(r.item || "").trim().length > 0 &&
          !r.duplicate &&
          !r.lockedBySug &&
          (r.isEditing || isNew);
        const readOnly = !r.isEditing && !isNew;

        const catSugs = openSugFor === `cat:${r.id}` ? getCatSuggestions(r.categorie) : [];
        const itemSugs =
          openSugFor === `item:${r.id}` ? getItemSuggestions(r.categorie, r.item).slice(0, 10) : [];

        return (
          <div className="Row Row--allergy" key={r.id} style={{ opacity: r._highlight ? 0.85 : 1 }}>
            {/* Catégorie */}
            <div className="RelBox CatBox">
              <input
                className={`Input md ${readOnly || r._highlight ? "is-readonly" : ""} ${r._highlight ? "is-catalog" : ""}`}
                placeholder="Catégorie"
                value={r.categorie}
                readOnly={readOnly || r._highlight}
                style={{ backgroundColor: r._highlight ? "#f0f7ff" : undefined, width: '200px' }}
                onFocus={() => {
                  if (!readOnly && !r._highlight) setOpenSugFor(`cat:${r.id}`);
                }}
                onChange={(e) => {
                  if (!r._highlight) onChangeCategorie(r.id, e.target.value);
                }}
                onBlur={() =>
                  setTimeout(
                    () => setOpenSugFor((p) => (p === `cat:${r.id}` ? null : p)),
                    120
                  )
                }
                onKeyDown={(e) => onKeyDown(e, r)}
              />
              {openSugFor === `cat:${r.id}` && !!catSugs.length && (
                <div className="SuggestPanel">
                  {catSugs.map((c) => (
                    <button
                      key={c}
                      type="button"
                      className="SuggestItem"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => chooseCategorie(r.id, c)}
                    >
                      {c}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Item + badges + actions — même conteneur inline-flex */}
            <div className="RelBox ItemBox">
              <div className="InputInline" >
                <input
                  className={`Input lg fill xc${r.duplicate ? "is-dup" : ""} ${
                    readOnly || r._highlight ? "is-readonly" : ""
                  } ${r._highlight ? "is-catalog" : ""}`}
                  style={{backgroundColor: r._highlight ? "#f0f7ff" : undefined, width: "200px"}}
                  placeholder="Item"
                  value={r.item}
                  readOnly={readOnly || r._highlight}
                  ref={(el) => {
                    if (el && focusId === r.id) {
                      try {
                        el.focus();
                        const L = el.value.length;
                        el.setSelectionRange(L, L);
                      } catch {}
                      setFocusId(null);
                    }
                  }}
                  onFocus={() => {
                    if (!readOnly) setOpenSugFor(`item:${r.id}`);
                  }}
                  onChange={(e) => onChangeItem(r.id, e.target.value)}
                  onBlur={() =>
                    setTimeout(
                      () => setOpenSugFor((p) => (p === `item:${r.id}` ? null : p)),
                      120
                    )
                  }
                  onKeyDown={(e) => onKeyDown(e, r)}
                  aria-invalid={r.duplicate ? "true" : "false"}
                />

                {/* badge inline */}
                {r._highlight && (
                  <span className="CatalogPill">📚 Catalogue</span>
                )}
                {!r._highlight && r.duplicate && (
                  <span className="DupPill DupPill--error">déjà dans la liste</span>
                )}
                {!r._highlight && !r.duplicate && r.inDb && r.isEditing && (
                  <span className="DupPill DupPill--info" title="Existe dans le catalogue">
                    existe déjà
                  </span>
                )}

                {/* actions collées à l'input */}
                <div className="Actions Actions--inline">
                  {(r.isEditing || isNew) && (
                    <button
                      className="IconBtn primary"
                      title={
                        r.lockedBySug
                          ? "Valeur choisie dans le catalogue — modifiez pour activer ✓"
                          : "Enregistrer"
                      }
                      onClick={() => saveRowById(r.id)}
                      disabled={!canSave || isSaving}
                    >
                      {isSaving ? "…" : "✓"}
                    </button>
                  )}
                  {!isNew && !r.isEditing && (
                    <button
                      className="IconBtn"
                      title="Éditer"
                      onClick={() => toggleEdit(r.id, true)}
                    >
                      ✎
                    </button>
                  )}
                  {!isNew && (
                    <button
                      className="IconBtn danger"
                      title="Supprimer"
                      onClick={() => remove(r.id)}
                    >
                      <X size={16} />
                    </button>
                  )}
                </div>
              </div>

              {/* suggestions item */}
              {openSugFor === `item:${r.id}` && (
                <div className="SuggestPanel">
                  {itemSugs.length > 0 ? (
                    itemSugs.map((it) => (
                      <button
                        key={it}
                        type="button"
                        className="SuggestItem"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => chooseItem(r.id, it)}
                        title="Choisir cet item"
                      >
                        {it}
                      </button>
                    ))
                  ) : (
                    <div className="SuggestItem muted">
                      {(r.categorie || "").trim()
                        ? "Aucun résultat"
                        : "Choisir d’abord une catégorie"}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}

      {/* CSS */}
      <style>{`
        /* 2 colonnes: Catégorie | Item (+actions) */
        .Row--allergy{
          display:grid;
          grid-template-columns: 220px 1fr;
          column-gap:3px;
          align-items:center;
          padding:6px 0;
          min-width:0;
        }

        .RelBox{ position:relative; }
        .ItemBox{ min-width:0; }

        /* COLLER les icônes à l'input */
        .InputInline{
          display:flex !important;
          align-items:center !important;
          gap:2px !important;             /* espace mini entre input et icônes */
          width:55% !important;
          min-width:0 !important;
        }
        .ItemBox .Input.fill{
          width:auto !important;           /* empêche l'input de pousser les icônes loin */
          flex:1 1 auto !important;        /* laisse de la place aux actions */
          min-width:120px !important;
        }

        .Actions--inline{
          display:inline-flex !important;
          gap:2px !important;
          flex:0 0 auto !important;       /* pas de wrap pour les icônes */
        }

        .IconBtn{
          border:1px solid #dbe3ff; background:#f6f8ff; color:#4d6bff;
          width:28px; height:28px; border-radius:999px;
          display:flex; align-items:center; justify-content:center;
        }
        .IconBtn.primary{ border-color:#cfe0ff; background:#eef3ff; color:#3f66ff; }
        .IconBtn.danger{ border-color:#ffd7d7; background:#fff1f1; color:#ff5c5c; }

        .DupPill{
          font-size:11px; border-radius:999px; padding:2px 8px; white-space:nowrap;
        }
        .DupPill--error{ background:#fee2e2; color:#b91c1c; }
        .DupPill--info{ background:#eef3ff; color:#3f66ff; }

        .is-readonly{ background:#f7f8fc; cursor:not-allowed; }
        .is-dup{ border-color:#ef4444!important; box-shadow:0 0 0 2px rgba(239,68,68,0.12)!important; }

        .SuggestPanel{
          position:absolute; z-index:50; top:55%; left:0; right:0; background:#fff;
          border:1px solid #e5e7eb; border-radius:8px; box-shadow:0 6px 24px rgba(0,0,0,.08);
          margin-top:6px; max-height:260px; overflow:auto;
        }
        .SuggestItem{ display:block; width:55%; text-align:left; padding:8px 10px; font-size:13px; }
        .SuggestItem:hover{ background:#f6f8ff; }
        .SuggestItem.muted{ color:#6b7280; }
        
        /* ===== DROPDOWN STYLES ===== */
        .SearchBar {
          position: relative;
          z-index: 1;
        }
        .SearchDropdown {
          position: absolute;
          top: 55%;
          left: 0;
          right: 0;
          width: 50%;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-top: none;
          border-radius: 0 0 8px 8px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
          max-height: 500px;
          overflow-y: auto;
          z-index: 9999;
        }
        .DropdownHeader {
          padding: 10px 12px;
          border-bottom: 1px solid #f0f0f0;
          background: #fafafa;
          font-weight: 600;
          color: #333;
          position: sticky;
          top: 0;
          z-index: 10000;
        }
        .DropdownItem {
          display: flex;
          width: 55%;
          padding: 10px 12px;
          border: none;
          background: transparent;
          text-align: left;
          cursor: pointer;
          border-bottom: 1px solid #f5f5f5;
          transition: background 0.15s;
        }
        .DropdownItem:last-child {
          border-bottom: none;
        }
        .DropdownItem:hover {
          background: #f9f9f9;
        }
        .DropdownItem.is-catalog {
          background: #f0f7ff;
        }
        .DropdownItem.is-catalog:hover {
          background: #e0f2ff;
        }
        .DropdownItemText {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          font-size: 13px;
        }
        .DropdownItemBadge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 999px;
          background: #dbeafe;
          color: #0369a1;
          font-size: 11px;
          white-space: nowrap;
          margin-left: auto;
          flex-shrink: 0;
        }
        .DropdownItemBadge.error {
          background: #fee2e2;
          color: #b91c1c;
        }
        .DropdownMore {
          padding: 10px 12px;
          text-align: center;
          background: #fafafa;
          border-top: 1px solid #f0f0f0;
          color: #999;
        }
      `}</style>
    </div>
  );
}
const PLUGIN_STORAGE_KEY = "doctolik-doctor-plugins";

const DEFAULT_PLUGINS = [
  { id: "timeline", name: "Timeline", description: "Chronologie visuelle des événements médicaux du patient.", color: "#e2678f", icon: Clock3, favorite: true },
  { id: "questionnaire", name: "Questionnaire", description: "Formulaires cliniques ouverts en consultation, avec score automatique.", color: "#e8a63a", icon: ClipboardList, favorite: true },
  { id: "atlas", name: "Atlas anatomique", description: "Atlas 3D du corps humain, consultable depuis la timeline de l'observation.", color: "#2f9e8f", icon: PersonStanding },
  { id: "odontogram", name: "Odontogramme", description: "Schéma dentaire du patient (caries, soins, prothèses, parodonte), enregistré à chaque consultation.", color: "#3b7bff", icon: Smile },
  { id: "bmi", name: "IMC", description: "Calcul de l'indice de masse corporelle (OMS), enregistré à chaque consultation avec l'historique du patient.", color: "#e50158", icon: Scale },
  { id: "vaccination", name: "Calendrier vaccinal", description: "Calendrier vaccinal obligatoire (Algérie, 2018 complété en 2026) : simulation selon l'âge, vaccins faits et retards.", color: "#0f9b7a", icon: Syringe },
  { id: "shortcuts", name: "Shortcuts", description: "Launch the plugins you choose directly from the consultation.", color: "#475569", icon: LayoutGrid },
];
// Plugins with their own configuration body and footer in the modal.
const CUSTOM_CONFIGURATION_PLUGINS = ["timeline", "questionnaire", "atlas", "odontogram", "bmi", "shortcuts"];
// Plugins without any setting: no "Configurer" button.
const UNCONFIGURABLE_PLUGINS = ["vaccination"];

function PluginsConfiguration() {
  const [plugins, setPlugins] = React.useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(PLUGIN_STORAGE_KEY));
      if (!Array.isArray(saved)) return DEFAULT_PLUGINS;
      // Keep the saved order and favorites of the existing plugins, and append plugins added since the list was saved.
      const known = new Set(DEFAULT_PLUGINS.map((plugin) => plugin.id));
      const kept = saved.filter((plugin) => known.has(plugin.id));
      const savedIds = new Set(kept.map((plugin) => plugin.id));
      return [
        // Name, description, colour and icon come from the plugin itself; the order and favorites from the saved list.
        ...kept.map((plugin) => ({
          ...DEFAULT_PLUGINS.find((defaultPlugin) => defaultPlugin.id === plugin.id),
          favorite: Boolean(plugin.favorite),
        })),
        ...DEFAULT_PLUGINS.filter((plugin) => !savedIds.has(plugin.id)),
      ];
    } catch {
      return DEFAULT_PLUGINS;
    }
  });
  const [search, setSearch] = React.useState("");
  const [configuredPlugin, setConfiguredPlugin] = React.useState(null);

  React.useEffect(() => {
    localStorage.setItem(PLUGIN_STORAGE_KEY, JSON.stringify(plugins.map(({ icon, ...plugin }) => plugin)));
  }, [plugins]);

  const visiblePlugins = plugins.filter((plugin) => {
    const term = search.trim().toLowerCase();
    return !term || plugin.name.toLowerCase().includes(term) || plugin.description.toLowerCase().includes(term);
  });
  const favorites = visiblePlugins.filter((plugin) => plugin.favorite);
  const others = visiblePlugins.filter((plugin) => !plugin.favorite);

  const toggleFavorite = (id) => setPlugins((current) => current.map((plugin) => plugin.id === id ? { ...plugin, favorite: !plugin.favorite } : plugin));
  const moveFavorite = (id, direction) => setPlugins((current) => {
    const favoritePlugins = current.filter((plugin) => plugin.favorite);
    const index = favoritePlugins.findIndex((plugin) => plugin.id === id);
    const target = index + direction;
    if (index < 0 || target < 0 || target >= favoritePlugins.length) return current;
    [favoritePlugins[index], favoritePlugins[target]] = [favoritePlugins[target], favoritePlugins[index]];
    const order = new Map(favoritePlugins.map((plugin, position) => [plugin.id, position]));
    return [...current].sort((a, b) => (order.has(a.id) ? order.get(a.id) : favoritePlugins.length) - (order.has(b.id) ? order.get(b.id) : favoritePlugins.length));
  });

  const renderIcon = (plugin) => {
    const Icon = plugin.icon || Settings;
    return <span className="PluginIcon" style={{ backgroundColor: plugin.color }}><Icon size={21} /></span>;
  };
  const configurePlugin = (plugin) => {
    setConfiguredPlugin(plugin);
  };
  const renderPluginConfiguration = (plugin) => {
    if (plugin.id === "timeline") return <TimelineEtapes />;
    if (plugin.id === "questionnaire") return <QuestionnairePlugin />;
    if (plugin.id === "atlas") return <AtlasPluginSettings onClose={() => setConfiguredPlugin(null)} />;
    if (plugin.id === "odontogram") return <OdontogramPluginSettings onClose={() => setConfiguredPlugin(null)} />;
    if (plugin.id === "bmi") return <BmiPluginSettings onClose={() => setConfiguredPlugin(null)} />;
    if (plugin.id === "shortcuts") return <ShortcutsPluginSettings plugins={plugins} onClose={() => setConfiguredPlugin(null)} />;
    return <div className="PluginModalBody"><label><span>Plugin actif</span><input type="checkbox" defaultChecked /></label><label><span>Rafraîchissement automatique</span><input type="checkbox" /></label><label>Emplacement<select defaultValue="Fiche patient"><option>Fiche patient</option><option>Onglet dédié</option><option>Dans la consultation</option><option>Dashboard</option></select></label></div>;
  };
  const renderFavorite = (plugin, index) => (
    <div className="PluginFavoriteRow" key={plugin.id}>
      <span className="PluginRank">{index + 1}</span>{renderIcon(plugin)}
      <div className="PluginInfo"><strong>{plugin.name}</strong><span>{plugin.description}</span></div>
      <div className="PluginActions">
        <button className="PluginIconButton" type="button" disabled={index === 0} onClick={() => moveFavorite(plugin.id, -1)} aria-label={`Monter ${plugin.name}`}><ChevronUp size={16} /></button>
        <button className="PluginIconButton" type="button" disabled={index === favorites.length - 1} onClick={() => moveFavorite(plugin.id, 1)} aria-label={`Descendre ${plugin.name}`}><ChevronDown size={16} /></button>
        <button className="PluginStar is-active" type="button" onClick={() => toggleFavorite(plugin.id)} aria-label={`Retirer ${plugin.name} des favoris`}><Star size={17} fill="currentColor" /></button>
        {!UNCONFIGURABLE_PLUGINS.includes(plugin.id) && <button className="PluginConfigure" type="button" onClick={() => configurePlugin(plugin)}>Configurer</button>}
      </div>
    </div>
  );
  const renderCard = (plugin) => (
    <article className="PluginCard" key={plugin.id}>
      <div className="PluginCardTop">{renderIcon(plugin)}<button className="PluginStar" type="button" onClick={() => toggleFavorite(plugin.id)} aria-label={`Ajouter ${plugin.name} aux favoris`}><Star size={17} /></button></div>
      <div className="PluginInfo"><strong>{plugin.name}</strong><span>{plugin.description}</span></div>
      {!UNCONFIGURABLE_PLUGINS.includes(plugin.id) && <button className="PluginConfigure" type="button" onClick={() => configurePlugin(plugin)}>Configurer</button>}
    </article>
  );

  return <div className="PluginsZone">
    <div className="PluginsHeader"><div><h2>Plugins</h2><p>Activez vos favoris pour les faire remonter en tête de liste et classez-les dans l'ordre qui vous convient. Chaque plugin se configure indépendamment.</p></div><label className="PluginSearch"><Search size={16} /><input value={search} onChange={(event) => setSearch(event.target.value)} /></label></div>
    {favorites.length > 0 && <><div className="PluginSectionTitle">Favoris</div><div className="PluginFavorites">{favorites.map(renderFavorite)}</div></>}
    <div className="PluginSectionTitle">Tous les plugins</div>
    {visiblePlugins.length === 0 ? <p className="PluginEmpty">Aucun plugin ne correspond à votre recherche.</p> : <div className="PluginGrid">{others.map(renderCard)}</div>}
    {configuredPlugin && <div className="PluginModalBackdrop" onClick={() => setConfiguredPlugin(null)}><div className={`PluginModal ${CUSTOM_CONFIGURATION_PLUGINS.includes(configuredPlugin.id) ? "PluginModal--wide" : ""}`} onClick={(event) => event.stopPropagation()}><div className="PluginModalHeader">{renderIcon(configuredPlugin)}<div><h3>Configuration - {configuredPlugin.name}</h3><span>Réglages propres à ce plugin</span></div><button className="PluginIconButton" type="button" onClick={() => setConfiguredPlugin(null)} aria-label="Fermer"><X size={18} /></button></div>{renderPluginConfiguration(configuredPlugin)}{!CUSTOM_CONFIGURATION_PLUGINS.includes(configuredPlugin.id) && <div className="PluginModalFooter"><button className="Btn Btn--ghost" type="button" onClick={() => setConfiguredPlugin(null)}>Annuler</button><button className="Btn" type="button" onClick={() => setConfiguredPlugin(null)}>Enregistrer</button></div>}</div></div>}
  </div>;
}

function SimpleListtt({ title = "Listes des diagnostics" }) {
  // id temporaire pour nouvelles lignes
  const cryptoRandom = React.useCallback(
    () => Math.random().toString(36).slice(2) + Date.now().toString(36),
    []
  );

  const [rows, setRows] = React.useState([]);
  const [allTitles, setAllTitles] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [openSugFor, setOpenSugFor] = React.useState(null);
  const [savingRow, setSavingRow] = React.useState({});
  const [q, setQ] = React.useState("");
  const [focusId, setFocusId] = React.useState(null); // pour mettre le focus
  const searchBarRef = React.useRef(null);

  const DOC_doctorId = React.useMemo(getDoctorIdFromLoginInfo, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
        setQ("");
      }
    };
    if (q) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [q]);

  // --------- helpers ----------
  const normalize = (s) =>
    String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  // présent dans le catalogue (autofill)?
  const inLibrary = React.useCallback(
    (label) => allTitles.some((t) => normalize(t) === normalize(label)),
    [allTitles]
  );

  // déjà dans la liste locale (du docteur)?
  const alreadyInList = React.useCallback(
    (label, excludeId = null) =>
      rows.some((r) => r.id !== excludeId && normalize(r.text) === normalize(label)),
    [rows]
  );

  const markRow = (id, patch) =>
    setRows((r) => r.map((x) => (x.id === id ? { ...x, ...patch } : x)));

  // bloque la saisie si pas en édition (sauf nouvelle ligne)
  const update = (id, v) =>
    setRows((r) =>
      r.map((x) => {
        if (x.id !== id) return x;
        const isNew = !x.exists || Number.isNaN(Number(x.id)) || Number(x.id) <= 0;
        if (!x.isEditing && !isNew) return x; // lecture seule si pas ✎
        const dup = alreadyInList(v, id);
        return {
          ...x,
          text: v,
          dirty: true,
          duplicate: dup,
          inDb: inLibrary(v),
        };
      })
    );

  const add = () => {
    const id = cryptoRandom();
    setRows((r) => [
      {
        id,
        text: "",
        exists: false,
        isEditing: true,
        dirty: false,
        duplicate: false,
        inDb: false,
      },
      ...r,
    ]);
    setFocusId(id);
  };

  const remove = async (id) => {
    if (!Number.isNaN(Number(id)) && Number(id) > 0 && DOC_doctorId) {
      try {
        await deleteDiagnosticApi(DOC_doctorId, Number(id));
      } catch {}
    }
    setRows((r) => r.filter((x) => x.id !== id));
  };

  // ✎ -> passe en édition + focus
  const toggleEdit = (id, on) => {
    markRow(id, { isEditing: on });
    if (on) setFocusId(id);
  };

  // choisir une suggestion : applique le texte, marque inDb, ne sauvegarde pas automatiquement
  const chooseFromSug = (id, value) => {
    const dup = alreadyInList(value, id);
    markRow(id, {
      text: value,
      dirty: true,
      isEditing: true,
      duplicate: dup,
      inDb: inLibrary(value),
    });
    setOpenSugFor(null);
    setFocusId(id);
  };

  const filteredRows = React.useMemo(() => {
    const needle = normalize(q);
    if (!needle) return rows;
    
    // Cherche dans rows (données locales)
    const inRows = rows.filter((r) => normalize(r.text).includes(needle));
    
    // Cherche dans le catalogue (allTitles)
    const inCatalog = (allTitles || [])
      .filter((t) => normalize(t).includes(needle))
      .map((title) => ({
        id: `cat_${title}`,
        text: title,
        exists: false,
        isEditing: false,
        dirty: false,
        duplicate: false,
        inDb: true,
        _highlight: true, // marquer comme du catalogue
      }))
      .filter((item) => !rows.some((r) => normalize(r.text) === normalize(item.text)));
    
    return [...inRows, ...inCatalog];
  }, [rows, q, allTitles]);

  // ---------- init ----------
  React.useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        // titres pour l'autofill (garde ton intégration existante)
        const res = await getDiagnosticTitlesApi();
        const data = res?.data;
        let titles = [];
        if (Array.isArray(data)) titles = data;
        else if (Array.isArray(data?.titles)) titles = data.titles;
        else if (Array.isArray(data?.data)) titles = data.data;
        setAllTitles((titles || []).filter((x) => typeof x === "string" && x.trim()));

        // diagnostics déjà enregistrés pour ce docteur
        if (DOC_doctorId) {
          const resp = await listDiagnosticsApi(DOC_doctorId);
          const payload = Array.isArray(resp?.data?.data)
            ? resp.data.data
            : Array.isArray(resp?.data)
            ? resp.data
            : [];
          const mapped = (payload || []).map((d) => ({
            id: d.id,
            text: d.nom || "",
            exists: true,
            isEditing: false,
            dirty: false,
            duplicate: false,
            inDb: inLibrary(d.nom || ""),
          }));
          setRows((prev) => (prev.length ? prev : mapped)); // ne pas écraser si déjà des lignes locales
        }
      } catch (e) {
        console.error("init diagnostics failed:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [DOC_doctorId]); // dep minimale

  // ---------- save ----------
  const saveRowById = async (rowId) => {
    if (!DOC_doctorId) return;
    const row = rows.find((x) => x.id === rowId);
    if (!row) return;

    const nom = String(row.text || "").trim();
    // bloque si vide, doublon local ou déjà au catalogue (autofill)
    if (!nom || row.duplicate || row.inDb) return;

    try {
      setSavingRow((m) => ({ ...m, [rowId]: true }));
      const payload = {};
      if (!Number.isNaN(Number(rowId)) && Number(rowId) > 0) payload.id = Number(rowId);
      payload.nom = nom;

      const resp = await saveDiagnosticApi(DOC_doctorId, payload);
      const saved = resp?.data ? resp.data.data || resp.data : payload;

      markRow(rowId, {
        id: saved?.id ?? rowId,
        text: saved?.nom ?? nom,
        exists: true,
        dirty: false,
        duplicate: false,
        isEditing: false, // sort du mode édition après save
        inDb: inLibrary(saved?.nom ?? nom),
      });

      if (saved?.nom && !allTitles.includes(saved.nom)) {
        setAllTitles((old) => old.concat([saved.nom]));
      }
    } catch (e) {
      const msg = String(e?.response?.data || "");
      if (msg.toLowerCase().includes("existe")) {
        markRow(rowId, { duplicate: true, isEditing: true });
        setFocusId(rowId);
      } else {
        console.error("saveDiagnosticApi failed:", e?.response?.data || e);
      }
    } finally {
      setSavingRow((m) => ({ ...m, [rowId]: false }));
    }
  };

  const handleBlur = (rowId) => {
    // ferme seulement le panneau de suggestions
    setTimeout(() => setOpenSugFor((p) => (p === rowId ? null : p)), 120);
  };

  const onKeyDown = (e, r) => {
    if (e.key === "Enter") {
      const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
      if (r.isEditing || isNew) {
        e.preventDefault();
        const nom = String(r.text || "").trim();
        if (nom && !r.duplicate && !r.inDb) saveRowById(r.id);
      }
    }
  };

  return (
    <div className="Card">
      <div className="CardHead">
        <span>{title}</span>
        <button className="Btn" onClick={add}>
          <Plus size={16} /> Ajouter
        </button>
      </div>

      <div className="SearchBar search-black narrow" ref={searchBarRef}>
        <Search size={16} />
        <input
          className="Input md"
          placeholder="Rechercher…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ fontSize: 13 }}
        />
        
        {/* Dropdown des résultats de recherche */}
        {q && filteredRows.length > 0 && (
          <div className="SearchDropdown">
            <div className="DropdownHeader">
              <strong style={{ fontSize: 12, color: "#666" }}>Résultats ({Math.min(filteredRows.length, 15)} / {filteredRows.length})</strong>
            </div>
            {filteredRows.slice(0, 15).map((result) => (
              <button
                key={result.id}
                type="button"
                className="DropdownItem"
                onClick={() => {
                  if (!result._highlight) {
                    toggleEdit(result.id, true);
                    setFocusId(result.id);
                  } else {
                    // Ajouter depuis le catalogue
                    const id = cryptoRandom();
                    const newRow = {
                      id,
                      text: result.text,
                      exists: false,
                      isEditing: true,
                      dirty: false,
                      duplicate: false,
                      inDb: true,
                    };
                    setRows((r) => [newRow, ...r]);
                    setFocusId(id);
                    setQ(""); // fermer dropdown
                  }
                }}
                title={result._highlight ? "Cliquer pour ajouter depuis le catalogue" : "Cliquer pour éditer"}
              >
                <span className="DropdownItemText">
                  {result.text}
                  {result.duplicate && !result._highlight && <span className="DropdownItemBadge error">Doublon</span>}
                </span>
              </button>
            ))}
            {filteredRows.length > 15 && (
              <div className="DropdownMore">
                <em style={{ fontSize: 12, color: "#999" }}>... et {filteredRows.length - 15} autres résultats (affinez votre recherche)</em>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="RowsCompact">
        {(q ? filteredRows : rows).map((r) => {
          // Si on a une recherche active, afficher seulement les résultats locaux
          if (q && r._highlight) return null;
          const n = normalize(r.text);
          const suggestions =
            r.isEditing && n.length > 0
              ? allTitles.filter((t) => normalize(t).includes(n)).slice(0, 8)
              : [];

          const isSaving = !!savingRow[r.id];
          const isNew = !r.exists || Number.isNaN(Number(r.id)) || Number(r.id) <= 0;
          // Désactive ✓ si champ vide, si doublon local OU si le titre existe déjà au catalogue (autofill)
          const canSave =
            String(r.text || "").trim().length > 0 &&
            !r.duplicate &&
            !r.inDb &&
            (r.isEditing || isNew);

          const readOnly = !r.isEditing && !isNew;

          return (
            <div className="Row Row--diag diag-grid" key={r.id} style={{ opacity: r._highlight ? 0.85 : 1 }}>
              {/* Champ + suggestions */}
              <div className="RelBox">
                <input
                  className={
                    "Input lg fill diag-search" +
                    (r.duplicate || r.inDb || r._highlight ? " is-dup" : "") +
                    (readOnly || r._highlight ? " is-readonly" : "") +
                    (r._highlight ? " is-catalog" : "")
                  }
                  style={{
                    backgroundColor: r._highlight ? "#f0f7ff" : undefined,
                    width: "200px",
                    fontSize: 13,
                  }}
                  value={r.text}
                  placeholder="Titre du diagnostic…"
                  readOnly={readOnly || r._highlight}
                  ref={(el) => {
                    if (el && focusId === r.id) {
                      try {
                        el.focus();
                        const L = el.value.length;
                        el.setSelectionRange(L, L);
                      } catch {}
                      setFocusId(null);
                    }
                  }}
                  onFocus={() => {
                    if (!readOnly && !r._highlight) setOpenSugFor(r.id);
                  }}
                  onChange={(e) => {
                    if (!r._highlight) {
                      update(r.id, e.target.value);
                      if (!readOnly) setOpenSugFor(r.id);
                    }
                  }}
                  onKeyDown={(e) => onKeyDown(e, r)}
                  onBlur={() => handleBlur(r.id)}
                  aria-invalid={r.duplicate || r.inDb ? "true" : "false"}
                  title={readOnly ? "Cliquez sur ✎ pour modifier" : undefined}
                />

                {/* Badge "catalogue" */}
                {r._highlight && (
                  <div className="DupBadge DupBadge--catalog">📚 Catalogue</div>
                )}

                {/* Badge "déjà dans la liste" (doublon local) */}
                {!r._highlight && r.duplicate && (
                  <div className="DupBadge DupBadge--error">existe déjà</div>
                )}

                {/* Badge "existe déjà" pour un titre du catalogue (autofill) */}
                {!r._highlight && !r.duplicate && r.inDb && r.isEditing && (
                  <div
                    className="DupBadge DupBadge--error"
                    title="Existe déjà dans le catalogue"
                  >
                    existe déjà
                  </div>
                )}

                {openSugFor === r.id && (loading || suggestions.length > 0) && (
                  <div className="SuggestPanel">
                    {loading && (
                      <div className="SuggestItem muted" style={{ fontSize: 12 }}>
                        Chargement…
                      </div>
                    )}
                    {!loading &&
                      suggestions.map((t, i) => (
                        <button
                          key={t + String(i)}
                          type="button"
                          className="SuggestItem"
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => chooseFromSug(r.id, t)}
                          title="Choisir ce titre"
                          style={{ fontSize: 12 }}
                        >
                          {t}
                        </button>
                      ))}
                  </div>
                )}
              </div>

              {/* Actions */}
              <div className="AfterInput diag-actions">
                {(r.isEditing || isNew) && (
                  <button
                    type="button"
                    className="IconBtn primary"
                    aria-label="Enregistrer"
                    title={
                      r.duplicate
                        ? "Déjà dans votre liste"
                        : r.inDb
                        ? "Existe déjà (catalogue)"
                        : "Enregistrer"
                    }
                    onClick={() => saveRowById(r.id)}
                    disabled={!canSave || isSaving}
                  >
                    {isSaving ? "…" : "✓"}
                  </button>
                )}

                {!isNew && !r.isEditing && (
                  <button
                    type="button"
                    className="IconBtn"
                    aria-label="Éditer"
                    title="Éditer"
                    onClick={() => toggleEdit(r.id, true)}
                  >
                    ✎
                  </button>
                )}

                {!isNew && (
                  <button
                    type="button"
                    className="IconBtn danger RowDelete"
                    aria-label="Supprimer"
                    title="Supprimer"
                    onClick={() => remove(r.id)}
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Styles intégrés (tu peux les déplacer dans ton CSS global) */}
      <style>{`
        .RowsCompact {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .diag-grid {
          display: grid;
          grid-template-columns: 1fr auto;
          gap: 8px;
          align-items: center;
        }
        .diag-actions {
          display: inline-flex;
          gap: 6px;
          align-items: center;
        }
        .IconBtn {
          border: 1px solid #dbe3ff;
          background: #f6f8ff;
          color: #4d6bff;
          width: 28px;
          height: 28px;
          border-radius: 999px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .IconBtn.primary {
          border-color: #cfe0ff;
          background: #eef3ff;
          color: #3f66ff;
        }
        .IconBtn.danger {
          border-color: #ffd7d7;
          background: #fff1f1;
          color: #ff5c5c;
        }
        .Row--diag .Input {
          min-height: 34px;
        }
        .is-readonly {
          background: #f7f8fc;
          cursor: not-allowed;
        }
        .is-dup {
          border-color: #ef4444 !important;
          box-shadow: 0 0 0 2px rgba(239,68,68,0.12) !important;
        }
        .DupBadge {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 11px;
          border-radius: 999px;
          padding: 2px 8px;
          pointer-events: none;
        }
        .DupBadge--error {
          background: #fee2e2;
          color: #b91c1c;
        }
        .DupBadge--catalog {
          background: #dbeafe;
          color: #0369a1;
        }
        .CatalogBadge {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 11px;
          border-radius: 999px;
          padding: 2px 8px;
          background: #dbeafe;
          color: #0369a1;
          pointer-events: none;
        }
        .CatalogPill {
          font-size: 11px;
          border-radius: 999px;
          padding: 2px 8px;
          background: #dbeafe;
          color: #0369a1;
        }
        .SuggestPanel {
          position: absolute;
          z-index: 30;
          top: 55%;
          left: 0;
          right: 0;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 6px 24px rgba(0,0,0,.08);
          margin-top: 6px;
          max-height: 260px;
          overflow: auto;
        }
        .SuggestItem {
          display: block;
          width: 55%;
          text-align: left;
          padding: 8px 10px;
        }
        .SuggestItem:hover {
          background: #f6f8ff;
        }
        .SuggestItem.muted {
          color: #6b7280;
        }
        
        /* ===== DROPDOWN STYLES ===== */
        .SearchBar {
          position: relative;
          z-index: 1;
        }
        .SearchDropdown {
          position: absolute;
          top: 55%;
          left: 0;
          right: 0;
          width: 50%;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-top: none;
          border-radius: 0 0 8px 8px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.15);
          max-height: 500px;
          overflow-y: auto;
          z-index: 9999;
        }
        .DropdownHeader {
          padding: 10px 12px;
          border-bottom: 1px solid #f0f0f0;
          background: #fafafa;
          font-weight: 600;
          color: #333;
          position: sticky;
          top: 0;
          z-index: 10000;
        }
        .DropdownItem {
          display: flex;
          width: 55%;
          padding: 10px 12px;
          border: none;
          background: transparent;
          text-align: left;
          cursor: pointer;
          border-bottom: 1px solid #f5f5f5;
          transition: background 0.15s;
        }
        .DropdownItem:last-child {
          border-bottom: none;
        }
        .DropdownItem:hover {
          background: #f9f9f9;
        }
        .DropdownItem.is-catalog {
          background: #f0f7ff;
        }
        .DropdownItem.is-catalog:hover {
          background: #e0f2ff;
        }
        .DropdownItemText {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 1;
          font-size: 13px;
        }
        .DropdownItemBadge {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 999px;
          background: #dbeafe;
          color: #0369a1;
          font-size: 11px;
          white-space: nowrap;
          margin-left: auto;
          flex-shrink: 0;
        }
        .DropdownItemBadge.error {
          background: #fee2e2;
          color: #b91c1c;
        }
        .DropdownMore {
          padding: 10px 12px;
          text-align: center;
          background: #fafafa;
          border-top: 1px solid #f0f0f0;
          color: #999;
        }
      `}</style>
    </div>
  );
}



/* ---------- utils ---------- */
function cryptoRandom() {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}
